<template xmlns="http://www.w3.org/1999/html">
  <div class="moyu-sidebar-nav" :class="{ 'nav-expanded': navExpanded2, 'dark-theme': isDark, 'light-theme': !isDark }">
    <!-- 左侧导航栏主菜单 -->
    <div class="moyu-nav-container">
      <!-- 顶部用户信息区域 -->
      <!-- 移动端头部 - 带关闭按钮 -->
      <div class="mobile-header" v-if="isMobile">
        <div class="mobile-header-content">
          <Avatar :src="userAvatar" size="small" class="mobile-avatar" />
          <div class="mobile-user-info">
            <div class="mobile-user-name">{{ userName }} ccc</div>
            <div class="mobile-user-rank">{{ rank || '修仙者' }}</div>
          </div>
        </div>
        <Icon type="md-close" @click="handleClose" class="mobile-close" />
      </div>
      <div class="moyu-user-info" v-if="!isMobile">
          <Avatar :src="userAvatar" size="large" class="moyu-user-avatar" />
          <span class="moyu-user-name" v-if="navExpanded" @click="toggleUserMenu" >{{ userName }}</span>
          <div class="theme-switcher">
<!--          <Button
            @click="toggleTheme"
            :type="isDark ? 'primary' : 'default'"
            size="small"
            icon="md-moon"
            class="theme-button"
          >
            {{ themeLabel }}
          </Button>-->
        </div>
        <Icon type="ios-arrow-down" v-if="navExpanded" class="moyu-user-arrow" />
      </div>

      <!-- 主菜单区域 -->
      <div class="moyu-main-menu">
        <div class="moyu-menu-item"
             v-for="item in mainMenu"
             :key="item.id"
             :class="{ 'active': item.active }"
             @click="handleMenuClick(item)"
             :title="!navExpanded ? item.name : ''">
          <Icon :type="item.icon" class="moyu-menu-icon" />
          <span class="moyu-menu-text" v-if="navExpanded">{{ item.name }}</span>
          <Badge :count="item.badge" v-if="item.badge" class="moyu-menu-badge" />
        </div>
        <div class="theme-switcher">
          <Button
            @click="toggleTheme"
            :type="isDark ? 'primary' : 'default'"
            size="small"
            icon="md-moon"
            class="theme-button"
          >
           {{ themeLabel }}
          </Button>
        </div>
      </div>

      <!-- 快捷操作区域 -->
      <div class="moyu-quick-actions" v-if="navExpanded">
        <div class="moyu-quick-title">
          <Icon type="ios-bolt" />
          <span>快捷操作</span>
        </div>
        <div class="moyu-quick-grid">
          <div class="moyu-quick-item"
               v-for="action in quickActions"
               :key="action.id"
               @click="handleQuickAction(action)">
            <Icon :type="action.icon" class="moyu-quick-icon" />
            <span class="moyu-quick-text">{{ action.name }}</span>
          </div>
        </div>
      </div>

      <!-- 底部功能区 -->
      <div class="moyu-bottom-menu">
        <div class="moyu-menu-item moyu-settings"
             @click="toggleSettings"
             :title="!navExpanded ? '设置' : ''">
          <Icon type="ios-settings" class="moyu-menu-icon" />
          <span class="moyu-menu-text" v-if="navExpanded">设置</span>
        </div>

        <div class="moyu-menu-item moyu-logout"
             @click="out"
             :title="!navExpanded ? '退出' : ''">
          <Icon type="ios-exit" class="moyu-menu-icon" />
          <span class="moyu-menu-text" v-if="navExpanded">退出</span>
        </div>
      </div>
    </div>
    <!-- 移动端遮罩层 -->
    <div class="mobile-overlay" v-if="isMobile && navExpanded" @click="navExpanded = false"></div>
    <!-- 子菜单弹窗 -->
    <Modal
      v-model="subMenuModal.visible"
      :title="subMenuModal.title"
      width="400"
      :mask-closable="true"
      :footer-hide="true"
      class="moyu-submenu-modal"
      :styles="{ top: '80px' }">
      <div class="moyu-submenu-content">
        <template v-if="currentSubMenu">
          <div v-for="item in currentSubMenu"
               :key="item.id"
               class="moyu-submenu-item"
               @click="handleSubMenuItem(item)">
            <Icon :type="item.icon" class="moyu-submenu-icon" />
            <span class="moyu-submenu-text">{{ item.name }}</span>
            <Badge :count="item.badge" v-if="item.badge" />
          </div>
        </template>
      </div>
    </Modal>
     <!-- 真灵觉醒提示框 -->
     <Modal v-model="JuexinEject" title="真灵觉醒提示" @on-ok="breachRequirt" :styles="{ top: '240px' }">
                  注意：真灵达到等级上限后才可觉醒！觉醒会继承原有真灵的被动神通，主动神通不保留。觉醒材料来自真灵游历，领取后直接进入角色背包。
                  <p v-if="zhenlingStuff.realmLevel">
                    觉醒等级要求: {{ zhenlingStuff.realmLevel }}
                  </p>
                  <p v-if="zhenlingStuff.realmName">
                    觉醒后真灵: {{ zhenlingStuff.realmName }}
                  </p>
                  <!-- <p v-if="zhenlingStuff.realmMaxPro">
                    突破最高概率: {{ zhenlingStuff.realmMaxPro }}
                  </p>
                  <p v-if="zhenlingStuff.realmDanYaoPro">
                    突破丹药几率: {{ zhenlingStuff.realmDanYaoPro }}
                  </p>
                  <p v-if="zhenlingStuff.realmDanYaoProTime">
                    突破丹药生效剩余时间(秒): {{ zhenlingStuff.realmDanYaoProTime }}
                  </p> -->
                  <p style="color: #2d8cf0" v-if="zhenlingStuff.materOneName">
                    {{ zhenlingStuff.materOneName }}: 需要
                    {{ zhenlingStuff.materOneNum }}
                  </p>
                  <p style="color: #2d8cf0" v-if="zhenlingStuff.materTwoName">
                    {{ zhenlingStuff.materTwoName }}: 需要
                    {{ zhenlingStuff.materTwoNum }}
                  </p>
                  <p style="color: #ff8c00" v-if="zhenlingStuff.materThreeName">
                    {{ zhenlingStuff.materThreeName }}: 需要
                    {{ zhenlingStuff.materThreeNum }}
                  </p>
                  <p v-if="zhenlingStuff.coin">
                    需要 {{ zhenlingStuff.coninType == 0 ? "金币" : "灵石" }}
                    {{ zhenlingStuff.coin }}
                  </p>
                </Modal>
    <!-- 真灵 -->
    <Modal
      width="1200"
      v-model="PetsEject"
      :styles="{ top: '70px' }"
      class-name="mobile-pet-modal mobile-feature-modal"
    >
      <Tabs v-model="petsActiveTab">
        <TabPane label="真灵列表" name="name1" >
          <div v-if="PetsList" class="aura-layout">
            <!-- 左边栏：真灵列表 -->
            <div v-if="!auraMobileDetailVisible" class="aura-left">
              <div class="aura-filter-panel">
                <Input
                  v-model.trim="auraFilters.keyword"
                  clearable
                  size="small"
                  placeholder="搜索真灵名/种族"
                  @input="handleAuraFilterChange"
                  @on-change="handleAuraFilterChange"
                />
                <div class="aura-filter-grid">
                  <Select
                    v-model="auraFilters.type"
                    size="small"
                    placeholder="类型"
                    @on-change="handleAuraFilterChange"
                  >
                    <Option :value="0">全部类型</Option>
                    <Option v-for="option in auraTypeOptions" :key="'aura-type-' + option.value" :value="option.value">
                      {{ option.label }}
                    </Option>
                  </Select>
                  <Select
                    v-model="auraFilters.element"
                    size="small"
                    placeholder="元素"
                    @on-change="handleAuraFilterChange"
                  >
                    <Option :value="0">全部元素</Option>
                    <Option v-for="option in auraElementOptions" :key="'aura-element-' + option.value" :value="option.value">
                      {{ option.label }}
                    </Option>
                  </Select>
                  <Select
                    v-model="auraFilters.grade"
                    size="small"
                    placeholder="品级"
                    @on-change="handleAuraFilterChange"
                  >
                    <Option :value="0">全部品级</Option>
                    <Option v-for="option in auraGradeOptions" :key="'aura-grade-' + option.value" :value="option.value">
                      {{ option.label }}
                    </Option>
                  </Select>
                  <Select
                    v-model="auraFilters.aptitude"
                    size="small"
                    placeholder="资质"
                    @on-change="handleAuraFilterChange"
                  >
                    <Option value="">全部资质</Option>
                    <Option v-for="option in auraAptitudeOptions" :key="'aura-aptitude-' + option.value" :value="option.value">
                      {{ option.label }}
                    </Option>
                  </Select>
                  <Select
                    v-model="auraFilters.status"
                    size="small"
                    placeholder="状态"
                    @on-change="handleAuraFilterChange"
                  >
                    <Option :value="-1">全部状态</Option>
                    <Option :value="1">出战中</Option>
                    <Option :value="0">休息中</Option>
                  </Select>
                  <Select
                    v-model="auraFilters.sortKey"
                    size="small"
                    placeholder="排序字段"
                    @on-change="handleAuraFilterChange"
                  >
                    <Option v-for="option in auraSortOptions" :key="'aura-sort-' + option.value" :value="option.value">
                      {{ option.label }}
                    </Option>
                  </Select>
                </div>
                <div class="aura-filter-actions">
                  <RadioGroup v-model="auraFilters.sortOrder" type="button" size="small" @on-change="handleAuraFilterChange">
                    <Radio label="desc">降序</Radio>
                    <Radio label="asc">升序</Radio>
                  </RadioGroup>
                  <Button size="small" @click="resetAuraFilters">重置</Button>
                  <Button size="small" type="error" @click="batchReleaseConfirm">放生全部</Button>
                </div>
                <div class="aura-filter-summary">
                  共 {{ filteredPetsList.length }} / {{ PetsList.length }} 只真灵
                </div>
              </div>
              <div class="aura-list">
                <div
                    v-for="item in filteredPetsList"
                    :key="item.auraId"
                    :class="['aura-list-item', { 'active': item.auraId === selectedAuraId }]"
                    @click="selectAura(item)"
                >
                  <div class="aura-item-content">
                    <div class="aura-item-icon">
                      <img
                          :src="item.auraIcon"
                          alt="真灵头像"
                          style="width: 40px; height: 40px; border-radius: 4px;"
                      />
                    </div>
                    <div class="aura-item-info">
                      <div class="aura-name">
                        {{ item.auraName }}
                        <Button
                          type="text"
                          size="small"
                          class="aura-follow-btn"
                          @click.stop="toggleAuraFollow(item)"
                        >
                          <Icon
                            :type="Number(item.auraFollowed || 0) === 1 ? 'ios-heart' : 'ios-heart-outline'"
                            :class="['aura-follow-icon', { active: Number(item.auraFollowed || 0) === 1 }]"
                          />
                        </Button>
                        <!--                          <span v-if="item.auraStatus == 1" class="fighting-tag">(出战中)</span>-->
                        <Tag size="small" :color="getGradeColor(item.auraGrade)">{{ getGradeName(item.auraGrade) }}</Tag>
                        <Tag v-if="item.auraStatus === 1" size="small" color="red">出战</Tag>
                      </div>
                      <div class="aura-brief">
                        <span>战力:{{ formatCombatPower(item.auraCombot) }}</span>
                        <span>体力:{{ item.auraStarvationValue }}</span>
                        <span>【Lv.{{ item.auraLevel }}】</span>
                      </div>
                      <div class="element-line">
                        <Icon type="ios-flame" :color="getElementColor(item.auraElement)" />
                        {{ getElementName(item.auraElement) }} · {{ getTypeName(item.auraType) }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="!filteredPetsList.length" class="aura-list-empty">
                  没有符合筛选条件的真灵
                </div>
              </div>
            </div>

            <!-- 右边栏：详细属性 -->
            <div class="aura-right" v-if="selectedAura && (!isMobile || auraMobileDetailVisible)">
              <div class="aura-detail">
                <div v-if="isMobile" class="aura-mobile-back">
                  <Button size="small" @click="backToAuraList">
                    <Icon type="ios-arrow-back" />
                    返回列表
                  </Button>
                </div>
                <div class="aura-header panel-compact">
                  <div class="aura-avatar-container">
                    <div class="avatar-frame">
                      <img :src="selectedAura.auraIcon" alt="真灵图片" class="aura-avatar-img"/>
                      <div class="level-badge">Lv.{{ selectedAura.auraLevel }}</div>
                    </div>
                    <div class="avatar-status" v-if="selectedAura.auraStatus == 1">
                      <span class="status-dot"></span>
                      <span>出战</span>
                    </div>
                    <div class="combat-box combat-box--under-avatar">
                      <div class="combat-label">战力</div>
                      <div class="combat-value">{{ selectedAura.auraCombot }}</div>
                    </div>
                  </div>

                  <div class="aura-basic-info">
                    <div class="info-header">
                      <div class="name-grade">
                        <h3 class="aura-name">{{ selectedAura.auraName }}</h3>
                        <span class="grade-tag"     :class="getGradeClass(selectedAura.auraGrade)" >{{ PetsGrade(selectedAura.auraGrade) }}</span>
                          <Button
                            size="small"
                            type="circle"
                            class="aura-follow-detail-btn"
                            @click="toggleAuraFollow(selectedAura)"
                          >
                            <Icon :type="Number(selectedAura.auraFollowed || 0) === 1 ? 'ios-heart' : 'ios-heart-outline'" />
                          </Button>
                          <Button size="small" type="circle" style="background-color: #2196F3;color: #ffffff; margin: 0 5px;" @click="editName(selectedAura)">
                            改名
                          </Button>
                           <Button size="small" type="circle" style="background-color: #C21F39;color: #ffffff; margin: 0 5px;" @click="ReleaseZhen(selectedAura)">
                            放生
                          </Button>
                          <Button size="small" type="circle" style="background-color: #2d8cf0;color: #ffffff; margin: 0 5px;" @click="goToWar(selectedAura)">
                            出战/休息
                          </Button>
                      </div>
                    </div>

                    <div class="exp-bar-mini">
                      <div class="exp-info">
                        <span>修为: {{ selectedAura.auraExp }}/{{ selectedAura.auraUpgradeExp }}</span>
                      </div>
                      <div class="exp-progress-container">
                        <div
                            class="exp-progress-fill"
                            :style="{ width: (selectedAura.auraExp / selectedAura.auraUpgradeExp * 100) + '%' }"
                        ></div>
                      </div>
                    </div>

                    <div class="info-grid-compact">
                      <div class="info-item">
                        <div class="item-icon">⭐</div>
                        <div class="item-content">
                          <div class="item-label">资质</div>
                          <div class="item-value"   :style="getAptitudeStyle(selectedAura.auraAptitude)" >{{ selectedAura.auraAptitude }}</div>
                        </div>
                      </div>

                      <div class="info-item">
                        <div class="item-icon">🌿</div>
                        <div class="item-content">
                          <div class="item-label">元素</div>
                          <div class="item-value">{{ petsEl(selectedAura.auraElement) }}</div>
                        </div>
                      </div>

                      <div class="info-item">
                        <div class="item-icon">🏷️</div>
                        <div class="item-content">
                          <div class="item-label">类型</div>
                          <div class="item-value">{{ petsType(selectedAura.auraType) }}</div>
                        </div>
                      </div>

                      <div class="info-item">
                        <div class="item-icon">👥</div>
                        <div class="item-content">
                          <div class="item-label">种族</div>
                          <div class="item-value">{{ selectedAura.auraRace }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 描述区域 -->
                <div class="section-title section-title--compact">背景故事</div>
                <div class="aura-description aura-description--compact">
                  {{ selectedAura.auraDesci || '暂无描述' }}
                </div>
<!-- 详情标签切换 -->
                <Tabs v-model="petDetailTab" class="aura-detail-tabs" :animated="false">
                  <!-- 属性·神通 -->
                  <TabPane label="属性·神通" name="attr">
                    <div class="attributes-grid">
                      <div class="attribute-row">
                        <div class="attribute-item">
                          <span class="attribute-label">灵力攻击:</span>
                          <span class="attribute-value">{{ selectedAura.auraMagicAttack || 0 }}</span>
                        </div>
                        <div class="attribute-item">
                          <span class="attribute-label">力道攻击:</span>
                          <span class="attribute-value">{{ selectedAura.auraAttack || 0 }}</span>
                        </div>
                        <div class="attribute-item">
                          <span class="attribute-label">生命值:</span>
                          <span class="attribute-value">{{ selectedAura.auraLife || 0 }}</span>
                        </div>
                      </div>
                      <div class="attribute-row">
                        <div class="attribute-item">
                          <span class="attribute-label">暴击:</span>
                          <span class="attribute-value">{{ (selectedAura.auraExplode * 100).toFixed(1) || 0 }}%</span>
                        </div>
                        <div class="attribute-item">
                          <span class="attribute-label">暴击伤害:</span>
                          <span class="attribute-value">{{ (selectedAura.auraCalDamage * 100).toFixed(1) || 0 }}%</span>
                        </div>
                        <div class="attribute-item">
                          <span class="attribute-label">饱食度:</span>
                          <span class="attribute-value">{{ selectedAura.auraStarvationValue || 0 }} </span>
                        </div>
                      </div>
                      <div class="attribute-row">
                        <div class="attribute-item">
                          <span class="attribute-label">物理防御力:</span>
                          <span class="attribute-value">{{ selectedAura.auraDefence || 0 }}</span>
                        </div>
                        <div class="attribute-item">
                          <span class="attribute-label">法术防御力:</span>
                          <span class="attribute-value">{{ selectedAura.auraMagicDefence || 0 }}</span>
                        </div>
                        <div class="attribute-item">
                          <span class="attribute-label">速度:</span>
                          <span class="attribute-value">{{ selectedAura.auraActionSpeed || 0 }}</span>
                        </div>
                      </div>
                      <div class="attribute-row">
                        <div class="attribute-item">
                          <span class="attribute-label">力道减伤:</span>
                          <span class="attribute-value">{{ (((selectedAura.auraLiDaoReductionRate || 0) * 100)).toFixed(1) }}%</span>
                        </div>
                        <div class="attribute-item">
                          <span class="attribute-label">灵力减伤:</span>
                          <span class="attribute-value">{{ (((selectedAura.auraLingLiReductionRate || 0) * 100)).toFixed(1) }}%</span>
                        </div>
                      </div>
                    </div>
                  <div v-if="selectedAura.gamePetSKillList && selectedAura.gamePetSKillList.length" class="skills-panel" style="margin-top: 16px;">
                      <div class="skills-columns">
                        <div class="skills-column">
                          <div class="skills-grid skills-grid--single">
                            <button
                              v-for="k in activeAuraSkills"
                              :key="'active-' + (k.skillId || k.skillName)"
                              type="button"
                              class="skill-item skill-card"
                              :class="{ 'is-selected': isSelectedAuraSkill(k) }"
                              @click="selectAuraSkill(k)"
                            >
                              <span class="skill-card-name">{{ k.skillName }}</span>
                            </button>
                            <div v-if="!activeAuraSkills.length" class="skill-empty">暂无主动神通</div>
                          </div>
                        </div>

                        <div class="skills-column">
                          <div class="skills-grid skills-grid--single">
                            <button
                              v-for="k in passiveAuraSkills"
                              :key="'passive-' + (k.skillId || k.skillName)"
                              type="button"
                              class="skill-item skill-card skill-card--passive"
                              :class="{ 'is-selected': isSelectedAuraSkill(k) }"
                              @click="selectAuraSkill(k)"
                            >
                              <span class="skill-card-name">{{ k.skillName }}</span>
                              <Tag size="small" :color="getAuraPassiveTypeColor(k)" class="skill-card-tag">
                                {{ getAuraPassiveTypeLabel(k) }}
                              </Tag>
                            </button>
                            <div v-if="!passiveAuraSkills.length" class="skill-empty">暂无被动神通</div>
                          </div>
                        </div>
                      </div>

                      <div class="skill-detail-card">
                        <div v-if="currentAuraSkill">
                          <div class="skill-detail-head">
                            <span class="skill-detail-name">{{ currentAuraSkill.skillName }}</span>
                            <Tag size="small" :color="isAuraPassiveSkill(currentAuraSkill) ? 'default' : 'primary'">
                              {{ isAuraPassiveSkill(currentAuraSkill) ? '被动' : '主动' }}
                            </Tag>
                            <Tag v-if="isAuraPassiveSkill(currentAuraSkill)" size="small" :color="getAuraPassiveTypeColor(currentAuraSkill)">
                              {{ getAuraPassiveTypeLabel(currentAuraSkill) }}
                            </Tag>
                          </div>
                          <div class="skill-detail-body">
                            {{ currentAuraSkill.skillDesc || '暂无技能描述' }}
                          </div>
                          <div class="skill-detail-meta" v-if="currentAuraSkill.conMana || currentAuraSkill.conMana === 0">
                            真气消耗: {{ currentAuraSkill.conMana }}
                          </div>
                        </div>
                        <div v-else class="skill-empty-detail">点击上面的技能查看详情</div>
                      </div>
                    </div>
                    <div v-else class="no-skills">暂无神通</div>
                  </TabPane>

                  <!-- 强化 -->
                  <TabPane label="强化" name="enhance">
                    <div class="aura-permanent-panel">
                      <div class="aura-permanent-toolbar">
                        <div class="aura-permanent-summary" v-if="selectedAura">
                          当前真灵: {{ selectedAura.auraName || '未选择' }}
                        </div>
                        <Button size="small" icon="ios-refresh" :loading="auraPermanentAttrLoading" @click="loadAuraPermanentAttrInfo">
                          刷新
                        </Button>
                      </div>
                      <div v-if="auraPermanentAttrLoading" class="aura-bag-empty">正在加载永久强化信息...</div>
                      <template v-else>
                        <div v-if="auraPermanentAttrConfigs.length" class="aura-permanent-grid">
                          <div
                            v-for="config in auraPermanentAttrConfigs"
                            :key="'perm-' + config.itemId"
                            class="aura-permanent-item"
                            :class="{ 'is-disabled': !canUseAuraPermanentAttr(config) }"
                          >
                            <div class="aura-permanent-head">
                              <div class="aura-permanent-name">{{ config.itemName }}</div>
                              <Tag :color="canUseAuraPermanentAttr(config) ? 'success' : 'default'">
                                {{ config.attrName }}
                              </Tag>
                            </div>
                            <div class="aura-permanent-desc">
                              每次增加 {{ formatAuraPermanentAttrDelta(config.attrType, config.delta) }}
                            </div>
                            <div class="aura-permanent-meta">
                              <span>拥有 {{ config.ownCount || 0 }}</span>
                              <span>已用 {{ config.useCount || 0 }}/{{ config.maxCount || 0 }}</span>
                              <span>累计 {{ formatAuraPermanentAttrDelta(config.attrType, config.totalValue || 0) }}</span>
                            </div>
                            <Button
                              size="small"
                              type="primary"
                              long
                              :disabled="!canUseAuraPermanentAttr(config)"
                              :loading="usingAuraPermanentAttrItemId === config.itemId"
                              @click="useAuraPermanentAttrMaterial(config)"
                            >
                              炼化强化
                            </Button>
                          </div>
                        </div>
                        <div v-else class="aura-bag-empty">暂无可用永久强化材料配置</div>

                        <div class="aura-permanent-records" v-if="auraPermanentAttrRecords.length">
                          <div class="aura-permanent-records__title">当前真灵累计强化</div>
                          <div class="aura-permanent-records__list">
                            <div v-for="record in auraPermanentAttrRecords" :key="'record-' + record.itemId" class="aura-permanent-record">
                              <span class="record-name">{{ record.attrName }}</span>
                              <span class="record-value">{{ formatAuraPermanentAttrDelta(record.attrType, record.totalValue || 0) }}</span>
                              <span class="record-count">使用 {{ record.useCount || 0 }} 次</span>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </TabPane>
                </Tabs>

                <!--    真灵装备        -->
                <!-- <div class="section-title" style="margin-top: 20px;">装备</div> -->
                <!-- <div class="pet-equipment-grid">
                 
                  <!-- <div class="pet-equipment-slot">
                    <div class="slot-label">宝具</div>
                    <div
                        class="slot-container"
                        @click="openPetEquipmentModal('treasure')"
                    >
                      <div v-if="selectedAura.equipTreasure" class="equipped-item">
                        <div class="item-icon">
                          <img
                              :src="selectedAura.equipTreasure.icon"
                              alt="宝具图标"
                              style="width: 40px; height: 40px;"
                          />
                        </div>
                        <div class="item-name">{{ selectedAura.equipTreasure.name }}</div>
                        <div class="item-grade">
                          <Tag :color="getEquipmentColor(selectedAura.equipTreasure.color)">
                            {{ getEquipmentGrade(selectedAura.equipTreasure.color) }}
                          </Tag>
                        </div>
                      </div>
                      <div v-else class="empty-slot">
                        <div class="slot-icon">+</div>
                        <div class="slot-hint">点击装备</div>
                      </div>
                    </div>
                    <Button
                        v-if="selectedAura.equipTreasure"
                        size="mini"
                        type="error"
                        ghost
                        @click.stop="unequipPetItem('treasure')"
                        class="unequip-btn"
                    >
                      卸下
                    </Button>
                  </div> -->

                
                  <!-- <div class="pet-equipment-slot">
                    <div class="slot-label">护符</div>
                    <div
                        class="slot-container"
                        @click="openPetEquipmentModal('talisman')"
                    >
                      <div v-if="selectedAura.equipTalisman" class="equipped-item">
                        <div class="item-icon">
                          <img
                              :src="selectedAura.equipTalisman.icon"
                              alt="护符图标"
                              style="width: 40px; height: 40px;"
                          />
                        </div>
                        <div class="item-name">{{ selectedAura.equipTalisman.name }}</div>
                        <div class="item-grade">
                          <Tag :color="getEquipmentColor(selectedAura.equipTalisman.color)">
                            {{ getEquipmentGrade(selectedAura.equipTalisman.color) }}
                          </Tag>
                        </div>
                      </div>
                      <div v-else class="empty-slot">
                        <div class="slot-icon">+</div>
                        <div class="slot-hint">点击装备</div>
                      </div>
                    </div>
                    <Button
                        v-if="selectedAura.equipTalisman"
                        size="mini"
                        type="error"
                        ghost
                        @click.stop="unequipPetItem('talisman')"
                        class="unequip-btn"
                    >
                      卸下
                    </Button>
                  </div> -->

                 
                  <!-- <div class="pet-equipment-slot">
                    <div class="slot-label">命玉</div>
                    <div
                        class="slot-container"
                        @click="openPetEquipmentModal('lifeJade')"
                    >
                      <div v-if="selectedAura.equipLifeJade" class="equipped-item">
                        <div class="item-icon">
                          <img
                              :src="selectedAura.equipLifeJade.icon"
                              alt="命玉图标"
                              style="width: 40px; height: 40px;"
                          />
                        </div>
                        <div class="item-name">{{ selectedAura.equipLifeJade.name }}</div>
                        <div class="item-grade">
                          <Tag :color="getEquipmentColor(selectedAura.equipLifeJade.color)">
                            {{ getEquipmentGrade(selectedAura.equipLifeJade.color) }}
                          </Tag>
                        </div>
                      </div>
                      <div v-else class="empty-slot">
                        <div class="slot-icon">+</div>
                        <div class="slot-hint">点击装备</div>
                      </div>
                    </div>
                    <Button
                        v-if="selectedAura.equipLifeJade"
                        size="mini"
                        type="error"
                        ghost
                        @click.stop="unequipPetItem('lifeJade')"
                        class="unequip-btn"
                    >
                      卸下
                    </Button>
                  </div> -->

                 
                  <!-- <div class="pet-equipment-slot">
                    <div class="slot-label">灵骨</div>
                    <div
                        class="slot-container"
                        @click="openPetEquipmentModal('spiritBone')"
                    >
                      <div v-if="selectedAura.equipSpiritBone" class="equipped-item">
                        <div class="item-icon">
                          <img
                              :src="selectedAura.equipSpiritBone.icon"
                              alt="灵骨图标"
                              style="width: 40px; height: 40px;"
                          />
                        </div>
                        <div class="item-name">{{ selectedAura.equipSpiritBone.name }}</div>
                        <div class="item-grade">
                          <Tag :color="getEquipmentColor(selectedAura.equipSpiritBone.color)">
                            {{ getEquipmentGrade(selectedAura.equipSpiritBone.color) }}
                          </Tag>
                        </div>
                      </div>
                      <div v-else class="empty-slot">
                        <div class="slot-icon">+</div>
                        <div class="slot-hint">点击装备</div>
                      </div>
                    </div>
                    <Button
                        v-if="selectedAura.equipSpiritBone"
                        size="mini"
                        type="error"
                        ghost
                        @click.stop="unequipPetItem('spiritBone')"
                        class="unequip-btn"
                    >
                      卸下
                    </Button>
                  </div> -->
                <!-- </div> -->


                <!-- 操作按钮 -->
                <div class="petsbtn" style="text-align: center;">
                  <Button size="small" type="circle" style="background-color: #00adff;color: #ffffff; margin: 0 5px;" @click="learnZhenSkill(selectedAura)">
                    学习神通
                  </Button>
                  <Button size="small" type="circle" style="background-color: #19be6b;color: #ffffff; margin: 0 5px;" @click="openDaShu(selectedAura)">
                    替换被动(打书)
                  </Button>
                  <Button size="small" type="circle" style="background-color: #00adff;color: #ffffff; margin: 0 5px;" @click="breach2(selectedAura)">
                    真灵觉醒
                  </Button>
                </div>
              </div>
            </div>

            <!-- 无选择时的提示 -->
            <div class="aura-right" v-else>
              <div class="no-selection">
                <p>请从左侧选择一个真灵查看详情</p>
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane label="真灵游历" name="name2" >
          <petMap v-if="petsActiveTab === 'name2'" @explore="petMap"/>
        </TabPane>
      </Tabs>

      <div slot="footer">
        <Button type="dashed" size="small" @click="PetsEject = false">
          关闭
        </Button>
      </div>
    </Modal>
      <!-- 真灵修炼神通 -->
      <Modal title="选择神通" v-model="shenEject" @on-ok="xiuLianZhenSKill" :styles="{ top: '100px' }">
        <Radio-group v-model="packItemId">
          <Radio v-for="(item, index) in checkShenSkillList" :key="item.packItemId || index" :label="item.packItemId">
            {{ item.itemName }}   *  {{ item.itemNum }} <span style="color: #cccccc"> {{ item.decs }} </span>
          </Radio>
        </Radio-group>
      </Modal>
      <Modal title="选择真灵书" v-model="daShuEject" @on-ok="daShuZhenSkill" :styles="{ top: '100px' }">
        <Radio-group v-model="daShuPackItemId">
          <Radio v-for="(item, index) in zhenBookList" :key="item.packItemId || index" :label="item.packItemId">
            {{ item.itemName }}   *  {{ item.itemNum }} <span style="color: #cccccc"> {{ item.decs }} </span>
          </Radio>
        </Radio-group>
      </Modal>
        <!-- 修改灵宠名称 -->
        <Modal title="修改灵宠名称" v-model="nameEject" @on-ok="reName" :styles="{ top: '100px' }">
          <Input v-model="auraName" placeholder="请输入名字" />
        </Modal>
        <!-- 组队 -->
        <Modal width="720" :title="organizeList.armyName ? organizeList.armyName : '组队'" v-model="organizeEject" :styles="{ top: '100px' }" class="organizeEject">
          <div v-for="(item, idx) in organizeList.charaInfoVoList" :key="idx" class="organizeList">
            <div v-if="item.avatar" style="position: relative; float: left">
              <img :src="item.avatar" alt="老弟,没图片找群主要啊" class="organizeList_face" />
              <span @click="kickOut(item)" v-if="item.status == 0">
                            <Icon type="md-close" style=" font-family:Ionicons" />
                        </span>
            </div>
            <div v-else style="
              text-align: center;
              font-size: 60px;
              cursor: pointer;
              position: relative;
              float: left;
            ">
              <Icon type="ios-body" class="organizeList_face" />

              <span @click="kickOut(item)" v-if="item.status == 0">
                            <Icon type="md-close" style=" font-family:Ionicons" />
                        </span>
            </div>
            <p class="organizeList_name" v-if="item.charaName">
              {{ item.charaName }} {{ item.charaLevel }} 级 副本剩余次数: {{item.rewardNum}}
            </p>
          </div>
          <Select v-model="mapName">
            <!-- ({{ item.minLv }}) -->
            <Option v-for="item in mapList" :value="item.mapName" :name="item.mapId" :key="item.mapId">
              {{ item.mapName }}{{ item.minLv }}-{{ item.maxLv }}
            </Option>
          </Select>
          <Button @click="CombatRecord()" :loading="recordStatus" style="margin-top: 10px">
            战斗记录
          </Button>
          <template v-if="combatRecordProcess">
            <p v-for="(item, idx) in combatRecordProcess" :key="item.reHealth" style="font-size: 18px; margin: 5px 0">
              第{{ ++idx }}场战斗
              <span style="color: red">
                            {{ combatRecordProcess.length == idx ? "失败" : "胜利" }}
                        </span>
              剩余 {{ item.reHealth }}血量  获取
              {{ item.dropExp }} 修为 物品: {{ item.gameItemsList1 || "空" }}
            </p>
          </template>
          <div slot="footer" >
            <Button type="circle" style="font-size: 12px;background-color: #00adff;color: #ffffff"  @click="join" v-if="teamStatus == 0">
              队伍列表
            </Button>
            <Button type="circle" style="font-size: 12px;background-color: #00adff;color: #ffffff"   @click="establish" v-if="teamStatus == 0">
              创建队伍
            </Button>
            <Button type="circle" style="font-size: 12px;background-color: #00adff;color: #ffffff"   @click="quitTheTeam" v-if="teamStatus == 1">
              退出队伍
            </Button>
          </div>
          <!-- 只添加这个开关按钮，放在合适的位置 -->
          <div style="margin-bottom: 10px; text-align: right;">
            <Button
              @click="toggleAutoKick"
              :type="autoKickEnabled ? 'error' : 'info'"
              size="small"
              :icon="autoKickEnabled ? 'md-power' : 'ios-cog-outline'"
            >
              {{ autoKickEnabled ? '关闭自动踢人' : '开启自动踢人' }}
            </Button>
            <span v-if="autoKickEnabled" style="margin-left: 10px; color: #ed4014; font-size: 12px;">
              ✓ 已开启自动踢人,默认最后一人
            </span>
          </div>
        </Modal>
        <!-- 捐献提示框 选择装备 -->
        <Modal v-model="donateEject" title="捐献选择装备" @on-ok="changeSmelt()" :styles="{ top: '100px' }">
          <Radio-group v-model="packItemId">
            <Radio v-for="(item, index) in checkboxList" :key="index" :label="item.packItemId" style="color: red">
              {{ item.itemName }}  品阶 {{item.scoreLevel}}
            </Radio>
          </Radio-group>

        </Modal>
        <Modal v-model="releaseEject" title="放生" @on-ok="Release">
          <p>确认要放生真灵吗？</p>
        </Modal>
        <Modal v-model="batchReleaseEject" title="批量放生" @on-ok="batchRelease">
          <p>确认要放生当前筛选出的 {{ filteredPetsList.length }} 只真灵吗？此操作不可撤销！</p>
        </Modal>
        <Modal v-model="exitSectEject" title="退出" @on-ok="deleTheSect">
          <p>退出宗门将清空所有贡献,是否退出</p>
        </Modal>
        <!-- 宝阁提示框 选择装备 -->
        <modal width="320px"   v-model="itemEject2" footer-hide="true" :styles="{ top: '100px' }">
          <div style="z-index:200;">
            <p :style="{ color: distinguishColor(item.color) }">
              {{ item.itemName }}
              <br>
              <span style="color: blue "  v-if="item.basicSocre != null ">
                灵气 ☪<label>{{item.basicSocre }}+{{item.appraisaScore }}</label>  <br> 品阶 {{item.scoreLevel}}
                                            </span>
            </p>
            <p>强化上限 <label style="color: darkred">{{  item.maxStrengthen }}</label></p>
            <p>洗练上限 <label style="color: darkred">{{ item.appraisalNum }}</label></p>
            <p>装备类型  <span style="color: #2e8bf0 ">{{ item.typeDec }}</span></p>
            <p>法器元素 <span style="color: #2e8bf0 ">{{ item.weaponTypeDec }}</span></p>
            <p>装备等级 <label style="color: darkred">{{ item.level }}</label></p>
            <!--              <p>物品状态 {{ item.bind == 0 ? "解绑" : "绑定" }}</p>-->
            <p>鉴定状态  <span style="color: #2e8bf0 ">{{ item.appraisal == 1 ? "已鉴定" : "未鉴定" }}</span></p>
            <p v-if="item.life" class="discrimination">
              生命值 <label style="color: darkred">{{ item.life }} ({{item.lifeRandom}})</label>
              <span v-if="item.strengLife">
                                                ({{ item.strengLife }})
                                            </span>
            </p>
            <p v-if="item.mana" class="discrimination">
              真气值 <label style="color: darkred">{{ item.mana }} ({{item.manaRandom}})</label>
              <span v-if="item.strengMana">
                                                ({{ item.strengMana }})
                                            </span>
            </p>
            <p v-if="item.attack" class="discrimination">
              攻击力 <label style="color: darkred">{{ item.attack }} ({{item.attackRandom}})</label>
              <span v-if="item.strengAttack">
                                                ({{ item.strengAttack }})
                                            </span>
            </p>
            <p v-if="item.magAttack" class="discrimination">
              法术攻击力 <label style="color: darkred">{{ item.magAttack }} ({{item.magAttackRandom}})</label>
              <span v-if="item.strengMagAttack">
                                                ({{ item.strengMagAttack }})
                                            </span>
            </p>
            <p v-if="item.defense" class="discrimination">
              物理防御力 <label style="color: darkred">{{ item.defense }} ({{item.defenseRandom}})</label>
              <span v-if="item.strengDefense">
                                                ({{ item.strengDefense }})
                                            </span>
            </p>
            <p v-if="item.magicDefense" class="discrimination">
              法术防御力 <label style="color: darkred">{{ item.magicDefense }} ({{item.magicDefenseRandom}})</label>
              <span v-if="item.strengMagicDefense">
                                                ({{ item.strengMagicDefense }})
                                            </span>
            </p>
            <p v-if="item.hitRate" class="discrimination">
              命中率 <label style="color: #801DAE">{{ (item.hitRate * 100).toFixed(2) }}% ({{item.hitRateRandom}})</label>
            </p>
            <p v-if="item.evade" class="discrimination">
              闪避率 <label style="color: #801DAE">{{ (item.evade * 100).toFixed(2) }}% ({{item.evadeRandom}})</label>
            </p>
            <p v-if="item.critical" class="discrimination">
              暴击率 <label style="color: #801DAE">{{ (item.critical * 100).toFixed(2) }}% ({{item.criticalRandom}})</label>
            </p>
            <p v-if="item.criDamage" class="discrimination">
              暴击伤害 <label style="color: #801DAE">{{ (item.criDamage * 100).toFixed(2) }}% ({{item.criDamageRandom}})</label>
            </p>
            <p v-if="item.armor"  class="discrimination">
              破甲 <span style="color: #801DAE">{{ (item.armor * 100).toFixed(2) }}%</span>
            </p>
            <p v-if="item.combo"  class="discrimination">
              连击 <span style="color: #801DAE">{{ (item.combo * 100).toFixed(2) }}%</span>
            </p>
            <p v-if="item.counter"  class="discrimination">
              反击 <span style="color: #801DAE">{{ (item.counter * 100).toFixed(2) }}%</span>
            </p>

            <p v-if="item.speed" class="discrimination">
              行动速度 <label style="color: #d88228">{{ item.speed }} ({{item.speedRandom}})</label>
            </p>
            <p v-if="item.physique" class="discrimination">
              根骨 <label style="color: #d88228">{{ item.physique }} ({{item.physiqueRandom}})</label>
              <span v-if="item.strengPhysique">
                                                ({{ item.strengPhysique }})
                                            </span>
            </p>
            <p v-if="item.dexterous" class="discrimination">
              力道 <label style="color: #d88228">{{ item.dexterous }} ({{item.dexterousRandom}})</label>
              <span v-if="item.strengDexterous">
                                                ({{ item.strengDexterous }})
                                            </span>
            </p>
            <p v-if="item.spirit" class="discrimination">
              灵力 <label style="color: #d88228">{{ item.spirit }} ({{item.spiritRandom}})</label>
              <span v-if="item.strengSpirit">
                                                ({{ item.strengSpirit }})
                                            </span>
            </p>
            <Divider v-if="item.affixVoList" />
            <template v-if="item.affixVoList">
              <p v-for="cz in item.affixVoList" :key="cz.affixDescribe" :style="{
                          color:
                            cz.affixLevel == 'T1'
                              ? '#ff8c00'
                              : 'rgb(73, 193, 248)',
                        }">
                【{{ cz.affixLevel }}】 {{ cz.affixDescribe }}
              </p>
            </template>
            <Divider v-if="item.decs" />
            <p v-if="item.decs">描述： {{ item.decs }}</p>
            <p v-if="item.suitName">共鸣名字: {{ item.suitName }}</p>
            <p v-if="item.suitOneDesc">共鸣效果: {{ item.suitOneDesc }}</p>
            <p v-if="item.suitDesc">共鸣描述: {{ item.suitDesc }}</p>
            <Divider v-if="item.skillDesc" />
            <p v-if="item.skillDesc">神通描述： {{ item.skillDesc }}</p>
            <Divider v-if="item.player" />
            <!--              <p v-if="item.player" ><Icon type="ios-navigate" /> 宗门：{{ item.player }}</p>-->
            <p v-if="item.player" ><Icon type="ios-navigate" style=" font-family:Ionicons" color="darkred"/> 贡献者：{{ item.player }}</p>
            <p v-if="item.contriPoint"><Icon type="ios-pricetags-outline" style=" font-family:Ionicons" color="darkred"/> 贡献点：{{ item.contriPoint }}</p>
          </div>
        </modal>
    <!-- 宗门弹窗 -->
    <!-- 原来的写法改为 -->
    <Modal
      width="1200" 
      v-model:visible="showClan"
      footer-hide
      :styles="{ top: '100px' }"
      class="clan-modal"
      @on-visible-change="handleClanModalVisible"
    >
      <ClanModal
        ref="clanModalRef"
        :isDark="isDark"
        @user-updated="refreshUserInfo"
        @package-updated="refreshPackage"
        @duel="handleDuel"
        @duel2="handleDuel2"
        @open-sect-boss-map="openSectBossTower"
        @open-sect-compe="openSectCompe"
      />
    </Modal>

    <!-- 宗门大比赛事页：海选 / 瑞士轮 / 淘汰赛对阵图，点任意一场回放战报 -->
    <Modal
      width="1100"
      title="宗门大比"
      v-model="showSectCompe"
      footer-hide
      :styles="{ top: '60px' }"
      class="sect-compe-modal"
    >
      <SectCompeModal :isDark="isDark" :visible="showSectCompe" @duel2="handleDuel2" />
    </Modal>

    <!-- 洞府系统Modal（外壳在父组件） -->
    <Modal
      width="1200"
      title=""
      v-model="caveVisible"
      :styles="{ top: '50px' }"
      :mask-closable="true"
      :closable="false"
      footer-hide
      class="cave-system-modal cave-farm-modal"
      @on-visible-change="handleCaveVisibleChange"
    >

      <CaveFarmSystem
        ref="caveFarmSystem"
        :visible="caveVisible"
        :player-level="playerLevel"
        :player-exp="playerExp"
        :player-max-exp="playerMaxExp"
        @exp-updated="handleCaveExpUpdated"
        @user-activity-refresh="$emit('user-activity-refresh')"
        @open-aura-modal="openPetsFromCave"
      />
    </Modal>

    <!-- 移动端导航与洞府灵兽园统一使用洞府版真灵弹窗。 -->
    <Modal
      width="1200"
      title=""
      v-model="caveAuraVisible"
      :styles="{ top: '50px' }"
      :mask-closable="true"
      :closable="false"
      footer-hide
      class="cave-aura-modal"
    >
      <CaveFarmAura :theme="'blue'" />
    </Modal>

    <!-- 经典洞府保留为独立入口，便于随时回退。 -->
    <Modal
      width="1200"
      title="经典洞府"
      v-model="classicCaveVisible"
      :styles="{ top: '50px' }"
      :mask-closable="false"
      class="cave-system-modal"
      @on-visible-change="handleClassicCaveVisibleChange"
    >
      <CaveSystem
        ref="caveSystem"
        :visible="classicCaveVisible"
        :player-level="playerLevel"
        :player-exp="playerExp"
        :player-max-exp="playerMaxExp"
        @exp-updated="handleCaveExpUpdated"
        @user-activity-refresh="$emit('user-activity-refresh')"
      />
    </Modal>

        <!-- 队伍名字弹出框 -->
        <Modal width="320"   title="队伍名字" v-model="armyEject" @on-ok="changeEstablish()" :styles="{ top: '100px' }">
          <div class="pasEject" style="height: 50px">
            <Input v-model="armyName" placeholder="请输入队伍名字" />
          </div>
          <div class="pasEject" >
            <Input v-model="armyLevel" placeholder="请输入队伍最低等级" />
          </div>
          <div class="pasEject" >
            <Select v-model="armyType" style="width:200px;margin: 10px 0">
              <Option v-for="item in armyTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </div>

        </Modal>

        <!-- 队伍列表弹出框 -->
        <Modal width="720"  title="队伍列表" v-model="armyListEject" :styles="{ top: '100px' }">
          <!--              v-model="sectEject3"-->
          <Table  stripe :columns="zcolumns2" :data="armyList">
            <template #name="{ row }">
              <strong>{{ row.name }}</strong>
            </template>
            <template #action="{ row, index }">
              <Button type="primary" size="small" style="margin-right: 5px" @click="JoinTheTeam(row)">加入队伍</Button>
              <!--                    <Button type="error" size="small" @click="remove(index)">Delete</Button>-->
            </template>
          </Table>
        </Modal>
        <Modal width="820"  title="切磋过程" v-model="duelEject" :styles="{ top: '100px' }">
          <div>
            <!-- 统计伤害   -->
            <div v-if="battleTotal" >
              演武场特殊效果：生命提升 200%
              战斗统计：
              <Table  ref="table"  size="small" :columns="columnsBattle" :data="battleTotalList"></Table>
            </div>
            <div class="monster" :class="[monsterList.length == 1 ? 'monstercenter' : '']">
              <Poptip trigger="hover" v-for="item in monsterList" :key="item.id" :title="item.name">
                敌人：{{ item.name }}
                <br>
                <Progress :percent="(Math.max(item.health, 0) / item.maxLife) * 100" stroke-color="#FF69B4" style="width: 250px">
                  <span>{{ item.health }}</span>
                </Progress>
                <div slot="content">
                  <p>生命值 {{ item.health }}</p>
                  <p>力道攻击 {{ item.physicalAttack }}</p>
                  <p>灵攻 {{ item.magicAttack }}</p>
                  <p>物理防御力 {{ item.defence }}</p>
                  <p>法术防御力 {{ item.magicDefense }}</p>
                  <p>命中率 {{ item.hitRate * 100 }}%</p>
                  <p>闪避率 {{ item.evade * 100 }}%</p>
                  <p>暴击率 {{ item.criticalHitValue * 100 }}%</p>
                  <p>暴击伤害 {{ item.critDamage * 100 }}%</p>
                  <p>行动速度 {{ item.movingSpeed }}</p>
                </div>
              </Poptip>
            </div>
            <div class="monster" :class="[gameCharacterVO.length == 1 ? 'monstercenter' : '']" v-if="this.teamStatus != 1">
              <Poptip trigger="hover" v-for="(item,idx) in gameCharacterVO" :key="idx" :title="item.name">
                {{ idx == 0 ? "角色: " : "真灵: " }}{{ item.name || "" }}
                <br>
                <Progress :percent="(Math.max(item.health || auraLife, 0) / item.formerHealth) * 100" style="width: 250px">
                  <span>{{ item.health || auraLife }}</span>
                </Progress>
                <div slot="content">
                  <p>生命值 {{ item.health }}</p>
                  <p>力道攻击 {{ item.physicalAttack }}</p>
                  <p>灵攻 {{ item.magicAttack }}</p>
                  <p>物理防御力 {{ item.defense }}</p>
                  <p>法术防御力 {{ item.magicDefense }}</p>
                  <p>命中率 {{ item.hitRate * 100 }}%</p>
                  <p>闪避率 {{ item.evade * 100  || 0}}%</p>
                  <p>暴击率 {{ (item.criticalHitValue * 100).toFixed(2)  || 0}}%</p>
                  <p>暴击伤害 {{ (item.critDamage * 100).toFixed(2) || 0 }}%</p>
                  <p>行动速度 {{ item.movingSpeed }}</p>
                </div>
              </Poptip>
            </div>
            <div class="recording" id="recording">
              <h2 style="margin-top: 20px" v-if="monsterList.length <= 0">暂无记录</h2>
              <battle-process2 v-bind:recordings="recording"></battle-process2>
            </div>
          </div>
        </Modal>
        <!-- 设置 -->
        <Modal width="760" title="地图掉落自动处理" v-model="setEject" :mask-closable="false" :styles="{ top: '36px' }" class="auto-rule-modal">
          <div class="auto-rule-toolbar">
            <div>
              <span class="auto-rule-toolbar-label">保留外处理方式</span>
              <RadioGroup v-model="gamePackageBo.isOpen" type="button" size="large">
                <Radio :label="1"><Icon type="ios-cash" /> 自动出售</Radio>
                <Radio :label="2"><Icon type="ios-hammer" /> 自动分解</Radio>
              </RadioGroup>
            </div>
            <Tag color="blue">仅地图新掉落装备  出售获得金币  分解获得洗练石</Tag>
          </div>

          <div class="auto-rule-workspace">
            <section class="auto-rule-column">
              <div class="auto-rule-column-title">
                <div><Icon type="ios-funnel" /> 基础保留规则</div>
                <span>四项同时命中</span>
              </div>

              <div class="auto-rule-section">
                <div class="auto-rule-section-head"><strong>装备等级</strong></div>
                <div class="auto-rule-level-range">
                  <InputNumber v-model="gamePackageBo.minLevel" :min="0" :max="999" placeholder="最低等级"></InputNumber>
                  <span>至</span>
                  <InputNumber v-model="gamePackageBo.maxLevel" :min="0" :max="999" placeholder="最高等级"></InputNumber>
                </div>
              </div>

              <div class="auto-rule-section">
                <div class="auto-rule-section-head">
                  <strong>品质</strong>
                  <span><button type="button" @click="selectAllAutoRule('quality')">全选</button><button type="button" @click="clearAutoRule('quality')">清空</button></span>
                </div>
                <CheckboxGroup v-model="gamePackageBo.quality" class="auto-rule-option-grid auto-rule-option-grid--quality">
                  <Checkbox v-for="option in autoRuleQualityOptions" :key="option.value" :label="option.value">
                    <i class="auto-rule-quality-dot" :style="{ backgroundColor: option.color }"></i>{{ option.label }}
                  </Checkbox>
                </CheckboxGroup>
              </div>

              <div class="auto-rule-section">
                <div class="auto-rule-section-head">
                  <strong>部位</strong>
                  <span><button type="button" @click="selectAllAutoRule('partList')">全选</button><button type="button" @click="clearAutoRule('partList')">清空</button></span>
                </div>
                <CheckboxGroup v-model="gamePackageBo.partList" class="auto-rule-option-grid auto-rule-option-grid--parts">
                  <Checkbox v-for="option in autoRulePartOptions" :key="option.value" :label="option.value">{{ option.label }}</Checkbox>
                </CheckboxGroup>
              </div>

              <div class="auto-rule-section">
                <div class="auto-rule-section-head">
                  <strong>元素</strong>
                  <span><button type="button" @click="selectAllAutoRule('elementList')">全选</button><button type="button" @click="clearAutoRule('elementList')">清空</button></span>
                </div>
                <CheckboxGroup v-model="gamePackageBo.elementList" class="auto-rule-option-grid auto-rule-option-grid--elements">
                  <Checkbox v-for="option in autoRuleElementOptions" :key="option.value" :label="option.value">
                    <i class="auto-rule-element-dot" :style="{ backgroundColor: option.color }"></i>{{ option.label }}
                  </Checkbox>
                </CheckboxGroup>
              </div>
            </section>

          </div>

          <div slot="footer" class="auto-rule-footer">
            <Button @click="setEject = false">取消</Button>
            <Button type="primary" :loading="autoRuleSaving" @click="changeSet">保存规则</Button>
          </div>
        </Modal>

        <!-- 攻略弹出框 -->
        <Modal width="720"  v-model="strategy" @on-ok="this.strategy = false" :styles="{ top: '40px' }">
          <updateLog></updateLog>
        </Modal>
        <!-- 频道弹出框 -->
        <Modal width="1050" title="频道" v-model="pindao" @on-ok="this.strategy = false" :styles="{ top: '40px' }">
          <Im ></Im>
        </Modal>
        <!-- 选择角色弹出框 -->
        <Modal width="620" title="切换角色" v-model="selectChara" @on-ok="this.selectChara = false" :styles="{ top: '40px' }">
          <selectChara></selectChara>
        </Modal>

        <Modal v-model="duihuanEject" title="兑换" @on-ok="duihuan">
          <p>确定兑换该法器吗</p>
        </Modal>

        <!-- 修改密码弹出框 -->
        <Modal width="620" title="修改密码" v-model="pasEject" @on-ok="confirmPassword()" :styles="{ top: '100px' }">
          <div class="pasEject">
            <Input v-model="originalPas" placeholder="请输入原密码" />
            <Input v-model="newPas" placeholder="请输入新密码" />
            <Input v-model="confirmPas" placeholder="确认密码" />
          </div>
        </Modal>

        <!-- 兑换码 -->
        <Modal width="620" title="兑换码" v-model="exchangeEject" @on-ok="changeExchange()" :styles="{ top: '100px' }">
          <Input v-model="exchange" placeholder="请输入兑换码" />
        </Modal>

        <!-- 新增留言 -->
        <Modal width="620" title="留音石" v-model="boardEject" @on-ok="changeBoard()" :styles="{ top: '100px' }">
          留言内容：
          <Input v-model="boardMsg"  placeholder="10贡献点留言一次"></Input>
        </Modal>

        <!-- 排行榜 -->
        <Modal
          width="1120"
          v-model="PlanEject"
          :styles="{ top: '60px' }"
          :footer-hide="true"
          :closable="false"
          :mask-closable="true"
          class-name="ranking-modal"
        >
          <rankingList></rankingList>
        </Modal>

        <!-- 任务 -->
<!--        <Modal style="font-family: STXinWei" footer-hide="true" width="1020" title="任务榜单" v-model="RackingEject" :styles="{ top: '100px' }" >
&lt;!&ndash;          <playersList></playersList>&ndash;&gt;

        </Modal>-->
      <!-- 任务榜单弹窗 -->
      <Modal
        footer-hide="true"
        width="1420"
        v-model="RackingEject"
        :styles="{ top: '10px' }"
        class-name="task-modal mobile-feature-modal"
        @on-visible-change="handleModalVisible"
      >
        <TaskSystemModal
          ref="taskSystemNormal"
          :visible="RackingEject"
          mode="normal"
          @close="RackingEject = false"
        />
      </Modal>

        <!-- 黑市 -->
        <Modal width="1080" v-model="tradingBankEject" :styles="{ top: '100px' }" class-name="mobile-market-modal mobile-feature-modal">
<!--         -->
          <Tabs>
            <TabPane label="珍宝阁" name="name4" >
              <synthesis-new v-if="tradingBankEject" ref="synthesisNew"></synthesis-new>
            </TabPane>
            <TabPane label="黑市" name="name3" >
              <tradingBank ref="tradingBank"></tradingBank>
            </TabPane>
          </Tabs>
        </Modal>

        <!-- 锁妖塔 -->
        <Modal  width="920"  v-model="lockDemonTowerEject" :styles="{ top: '100px' }">
          <Tabs value="name1">
            <TabPane label="锁妖塔" name="name1" >
              <lockDemonTower ref="lockDemonTower"></lockDemonTower>
            </TabPane>
            <TabPane label="灶火祈福" name="name5" >
              <hearthActivity ref="hearthActivity"></hearthActivity>
            </TabPane>
          </Tabs>
        </Modal>

    </div>

</template>

<script>
import playersList from "./playersList.vue";
import TaskSystemModal from "./TaskSystemModal.vue";
import ClanModal from './ClanModal.vue'
import SectCompeModal from './SectCompeModal.vue'
import rankingList from "./rankingList.vue";
import updateLog from "./updateLog.vue";
import selectChara from "./selectChara.vue";
import tradingBank from "./tradingBank.vue";
import shop from "./shop.vue";
import synthesisNew from "./synthesisNew";
import hearthActivity from "./hearthActivity.vue";
import lockDemonTower from "./lockDemonTower.vue";
import petMap from "./petMap.vue";
import { Vue } from 'vue';
import Im from "./Im";
import alchemyFurnace from './alchemyFurnace.vue';
import CaveSystem from "./CaveSystem.vue";
import CaveFarmSystem from "./CaveFarmSystem.vue";
import CaveFarmAura from "./cave-farm/CaveFarmAura.vue";
import qs from "query-string";
import { sleep } from "../utils";
import battleProcess2 from "./battleProcess2";

export default {
    name: "headers2",
    props: {
      navExpanded: {  // 改为从父组件传入
        type: Boolean,
        default: true
      }
    },
    data() {
        return {
          playerLevel: 8,      // 传给子组件的数据
          playerExp: 1500,
          playerMaxExp: 0,

          // 新增的数据
          petEquipmentModalVisible: false,
          petEquipmentDetailVisible: false,
          currentEquipmentSlot: '', // 当前正在操作的装备槽位
          petEquipmentTypeFilter: 'all',
          petEquipmentQualityFilter: 'all',
          selectedPetEquipmentDetail: null,

          // 装备数据示例结构（实际需要从后端获取）
          petEquipmentList: [
            {
              id: 1,
              name: '龙纹宝具',
              type: 'treasure',
              color: 4,
              icon: '/path/to/icon.png',
              level: 50,
              enhanLevel: 3,
              attack: 150,
              magAttack: 120,
              life: 500,
              // ...其他属性
            },
            // ...更多装备
          ],

          showClan: false,
          // 宗门大比赛事页开关
          showSectCompe: false,
          clanTitle: '宗门',
          // 导航栏状态
          // 默认
          navExpanded2: false,
          isMobile: false,
          isMobile2: false,
          isDark: false,
          isGray: false,
          // 用户信息
          userName: "修仙者",
          rank:"未入门",
          userAvatar: "https://example.com/avatar.jpg",

          // 主菜单配置
          mainMenu: [
            { id: 'forge', name: '洞府', icon: 'ios-home', active: false },
            { id: 'classicCave', name: '经典洞府', icon: 'ios-home-outline', active: false },
          /*  { id: 'tower', name: '秘境', icon: 'ios-navigate', active: false },*/
            { id: 'sect', name: '宗门', icon: 'ios-heart', active: false },
            { id: 'pet', name: '真灵', icon: 'ios-paw', active: false },
            { id: 'task', name: '任务', icon: 'md-compass', active: false},
            // { id: 'team', name: '组队', icon: 'ios-people', active: false },
            { id: 'rank', name: '排行榜', icon: 'ios-apps', active: false },
            { id: 'farm', name: '灵田', icon: 'ios-leaf', active: false },
            { id: 'monopoly', name: '问道棋局', icon: 'ios-map', active: false },
            { id: 'rogue', name: '太虚劫境·测试', icon: 'ios-git-branch', active: false },
          ],

          // 快捷操作
          quickActions: [
            { id: 'sign', name: '签到', icon: 'ios-checkmark-circle', handler: 'signIn' },
            { id: 'code', name: '兑换码', icon: 'ios-key', handler: 'openExchange' },
            { id: 'switch', name: '切换角色', icon: 'md-swap', handler: 'openSelectChara' },
            { id: 'sell', name: '出售设置', icon: 'ios-settings', handler: 'openSetEject' },
            { id: 'chat', name: '频道', icon: 'ios-chatbubbles', handler: 'openPindao' },
            { id: 'help', name: '帮助', icon: 'ios-help-circle', handler: 'openHelpDocument' },
          ],

          // 子菜单配置
          subMenus: {
            // 这里可以添加更多子菜单配置
          },

          // 子菜单弹窗
          subMenuModal: {
            visible: false,
            title: '',
            type: ''
          },
          discipleTableData: [],  //表格源数据
          discipleTempData: [],   //表格显示数据
          discipleCurrentPage: 1,  //当前页
          discipleTotal: 0,   //数据总数
          limFlag:false,
          disciplePageSize: 15,   //一页展示的条数  默认一页展示10条，有很多数据就可以写其他的数
          inputContent: '',  //搜索的数据值
          columnsBattle: [
              {
                title: '名称',
                key: 'name',
                fixed: 'left',
                width: 200,
              },
              {
                title: '治疗',
                key: 'zhiliao',
                width: 100,
                sortable: true
              },
              {
                title: '回蓝',
                key: 'huilan',
                width: 100,
                sortable: true
              },
              {
                title: '伤害',
                key: 'damage',
                width: 100,
                sortable: true
              },
              {
                title: '普攻',
                key: 'attack',
                width: 100,
                sortable: true
              },
              {
                title: '力道',
                key: 'lidao',
                width: 100,
                sortable: true
              },
              {
                title: '灵力',
                key: 'lingli',
                width: 100,
                sortable: true
              },
              {
                title: '持续',
                key: 'sustained',
                width: 100,
                sortable: true
              },
              {
                title: '反击',
                key: 'counterattack',
                width: 100,
                sortable: true
              },
              {
                title: '被控制',
                key: 'control',
                width: 100,
                sortable: true
              }
            ],
            zcolumns2: [
              {
                title: '队伍名',
                key: 'armyName',
                width: 150
              },
              {
                title: '队伍类型',
                key: 'armyType',
                render: (h, params) => {
                  switch (params.row.armyType) {
                    case 1:
                      return h('span', '普通');
                      break;
                    case 2:
                      return h('span', '挑战');
                      break;
                  }
                },
              },
              {
                title: '加入等级',
                key: 'armyLevel'
              },
              {
                title: '队长',
                key: 'captainName'
              },
              {
                title: '剩余位置',
                key: 'armyNum'
              },
              {
                title: '操作',
                slot: 'action',
                width: 120,
                align: 'center'
              }
            ],
            monsterList: [],
            gameCharacterVO: [],
            gamePetVOList: [],
            recording: [],
            recordStatus: false, // 战斗记录的一个状态
            mapName: "", // 选择查看的地图名字
            battleTotal: false, // 战斗统计弹出框
            battleTotalList: [],//战斗统计列表
            battleObject: {
              name: "",
              damage: 0,
              attack: 0,
              lidao: 0,
              lingli: 0,
              zhiliao: 0,
              huilan: 0,
              sustained: 0,
              counterattack: 0,
              control: 0,
            },
            strategy: false, // 攻略弹出框
            pindao:false,
            selectChara: false,
            pasEject: false, // 修改密码弹出框
            exchangeEject: false, // 兑换码弹出框
            boardEject: false, // 留言弹出框
            PlanEject: false, // 排行榜弹出框
            RackingEject: false, // 在线玩家弹出框
            organizeEject: false, // 组队弹出框
            sectEject: false, // 宗门弹出框
          // 改为：
          caveVisible: false, // 种田洞府系统弹窗
          classicCaveVisible: false, // 经典洞府独立弹窗

          sectEject2: false, // 宗门列表
            itemEject2: false, // 宗门宝阁装备详情
            tzitemEject2: false, // 图纸所需详
            gamFordrawingBo: {
              // 出售设置
              charaId: "",
              packItemIds: "",
              matList: [],
              type: 1,
            },
            formulaBo: {
              itemId:null,
              haveNum:0
            },
            duihuanEject: false,
            indexDH:0,
            gameSectItemBo: {
              // 查询宝库设置
              charaId: "",
              sectId: null,
              level:null,
              page: 1,
              pageSize:15,
              name: null,
              element: null,
            },
            item:{},
            zhenitem:{},
            discipleId:'',
            auraName: "",
            auraId: "",
            nameEject: false,
            shenEject: false,
            daShuEject: false,
            donateEject: false, // 捐献提示框
            JuexinEject: false, // 真灵觉醒提示框
            exitSectEject: false, // 退出提示框
            releaseEject: false, // 放生提示框
            batchReleaseEject: false, // 批量放生提示框
            checkboxList:[],//选择装备捐献
            checkShenSkillList:[],//选择神通学习
            zhenBookList:[],//选择真灵书
            packItemId:"",//捐献需要用到的 捐献选择的装备
            daShuPackItemId:"",//打书需要的真灵书
            sectEject3: false, // 宗门列表
            armyEject: false, // 队伍名字的弹出框
            armyListEject: false, // 队伍列表弹出框
            duelEject: false, // 切磋记录弹出框
            setEject: false, // 设置自动出售
            originalPas: "", // 原密码
            newPas: "", // 新密码
            confirmPas: "", // 确认密码
            mapLootsList: undefined, // 地图掉落
            exchange: "", // 兑换码
            boardMsg: "", // 留言内容
            teamStatus: 0, // 组队状态 0 无队伍 1有队伍
            sectStatus: 0, // 宗门状态 0 无宗门 1有宗门
            armyName: "", //  队伍名字
            armyLevel: 0, //  队伍等级
            armyType: 1, //  队伍类型
            armyTypeList: [
              {
                value: '1',
                label: '普通'
              },
              {
                value: '2',
                label: '挑战'
              }
            ],
            armyList: [], // 队伍列表
            organizeList: [], // 组队列表
            total: 0,
            //pageSize: 20,
            mapList: [], // 地图列表
            mapid: "", // 地图id
            combatRecordProcess: [], // 战斗记录过程
            gamePackageBo: {
                // 出售设置
                charaId: "",
                isOpen: 1,
                maxLevel: 999,
                minLevel: 1,
                quality: [],
                partList: [],
                elementList: [],
            },
            autoRuleSaving: false,
            autoRuleQualityOptions: [
              { value: "3", label: "良品", color: "#38a169" },
              { value: "4", label: "上品", color: "#3182ce" },
              { value: "5", label: "绝品", color: "#805ad5" },
              { value: "6", label: "灵宝", color: "#d69e2e" },
            ],
            autoRulePartOptions: [
              { value: 1, label: "武器" },
              { value: 2, label: "玄端" },
              { value: 3, label: "头冠" },
              { value: 4, label: "项链" },
              { value: 7, label: "戒指" },
              { value: 8, label: "绶佩" },
              { value: 9, label: "绶带" },
              { value: 10, label: "鞜履" },
              { value: 11, label: "法宝" },
            ],
            autoRuleElementOptions: [
              { value: 1, label: "金", color: "#d5a62f" },
              { value: 2, label: "木", color: "#3f9b63" },
              { value: 3, label: "水", color: "#3488c9" },
              { value: 4, label: "火", color: "#d94f45" },
              { value: 5, label: "土", color: "#9b7045" },
              { value: 6, label: "风", color: "#65a9a2" },
              { value: 7, label: "雷", color: "#7658b8" },
              { value: 8, label: "冰", color: "#65bcd4" },
            ],
            PetsEject: false, // 旧版真灵弹出框
            caveAuraVisible: false, // 洞府版真灵弹出框
            petsActiveTab: 'name1', // 真灵弹窗当前激活的tab
            petDetailTab: 'attr', // 真灵详情tab: attr/skill/bag/enhance
            PetsList: [],
            auraFilters: {
              keyword: "",
              type: 0,
              element: 0,
              grade: 0,
              aptitude: "",
              status: -1,
              sortKey: "combat",
              sortOrder: "desc",
            },
            auraTypeOptions: [
              { value: 1, label: "辅助" },
              { value: 2, label: "输出" },
              { value: 3, label: "防御" },
            ],
            auraElementOptions: [
              { value: 1, label: "金" },
              { value: 2, label: "木" },
              { value: 3, label: "水" },
              { value: 4, label: "火" },
              { value: 5, label: "土" },
              { value: 6, label: "风" },
              { value: 7, label: "雷" },
              { value: 8, label: "冰" },
            ],
            auraGradeOptions: [
              { value: 1, label: "普通" },
              { value: 2, label: "稀有" },
              { value: 3, label: "灵级" },
              { value: 4, label: "王级" },
              { value: 5, label: "域级" },
              { value: 6, label: "圣级" },
              { value: 7, label: "神级" },
            ],
            auraAptitudeOptions: [
              { value: "10-", label: "10以下" },
              { value: "9-", label: "9以下" },
              { value: "8-", label: "8以下" },
              { value: "7-", label: "7以下" },
              { value: "6-", label: "6以下" },
            ],
            auraSortOptions: [
              { value: "combat", label: "按战力" },
              { value: "level", label: "按等级" },
              { value: "aptitude", label: "按资质" },
              { value: "grade", label: "按品级" },
              { value: "starvation", label: "按体力" },
              { value: "life", label: "按生命" },
              { value: "attack", label: "按力攻" },
              { value: "magicAttack", label: "按灵攻" },
              { value: "speed", label: "按速度" },
            ],
            auraMobileDetailVisible: false,
            selectedAuraId: null, // 新增：当前选中的真灵ID
            selectedAura: null,   // 新增：当前选中的真灵对象
            selectedAuraSkillKey: null,
            auraPermanentAttrLoading: false,
            auraPermanentAttrInfo: null,
            auraPermanentMaterialBag: [],
            usingAuraPermanentAttrItemId: null,
            zhenlingStuff: [], // 觉醒的材料
            Pets: null,
            isActive:false, // 切换主体
            electronicEquipment: false, // 电子设备
            tradingBankEject: false, // 黑市
            lockDemonTowerEject: false,//锁妖塔
            tradingBankList: [],
            // ============ 新增的自动踢人相关参数 ============
            // 自动踢人开关
            autoKickEnabled: false,

            // 自动踢人定时器
            autoKickTimer: null,

            // 定时检查间隔（毫秒），默认60秒
            autoKickInterval: 60000,
        };
    },
    computed: {
      themeLabel() {
        return this.isDark ? '夜间' : this.isGray ? '灰度' : '白天';
      },
      currentSubMenu() {
        return this.subMenus[this.subMenuModal.type];
      },
      filteredPetsList() {
        const filters = this.auraFilters || {};
        let list = Array.isArray(this.PetsList) ? this.PetsList.slice() : [];
        const keyword = (filters.keyword || "").trim().toLowerCase();

        if (keyword) {
          list = list.filter((item) => {
            const fields = [
              item.auraName,
              item.auraRace,
              this.getElementName(item.auraElement),
              this.getTypeName(item.auraType),
              this.PetsGrade(item.auraGrade),
            ];
            return fields.some((field) => String(field || "").toLowerCase().includes(keyword));
          });
        }

        if (Number(filters.type) > 0) {
          list = list.filter((item) => Number(item.auraType) === Number(filters.type));
        }
        if (Number(filters.element) > 0) {
          list = list.filter((item) => Number(item.auraElement) === Number(filters.element));
        }
        if (Number(filters.grade) > 0) {
          list = list.filter((item) => Number(item.auraGrade) === Number(filters.grade));
        }
        if (Number(filters.status) >= 0) {
          list = list.filter((item) => Number(item.auraStatus) === Number(filters.status));
        }
        if (filters.aptitude) {
          list = list.filter((item) => this.matchAuraAptitude(item.auraAptitude, filters.aptitude));
        }

        const direction = filters.sortOrder === "asc" ? 1 : -1;
        const sortKey = filters.sortKey || "combat";
        list.sort((a, b) => {
          const followedDiff = Number(b && b.auraFollowed || 0) - Number(a && a.auraFollowed || 0);
          if (followedDiff !== 0) {
            return followedDiff;
          }
          const valueA = this.getAuraSortValue(a, sortKey);
          const valueB = this.getAuraSortValue(b, sortKey);
          if (valueA === valueB) {
            return Number(a.auraId || 0) - Number(b.auraId || 0);
          }
          return valueA > valueB ? direction : -direction;
        });

        return list;
      },
      activeAuraSkills() {
        return this.getAuraSkillsByType('active');
      },
      passiveAuraSkills() {
        return this.getAuraSkillsByType('passive');
      },
      currentAuraSkill() {
        const skills = this.selectedAura && this.selectedAura.gamePetSKillList
          ? this.selectedAura.gamePetSKillList
          : [];
        if (!skills.length) return null;
        return skills.find((item) => this.getAuraSkillKey(item) === this.selectedAuraSkillKey) || skills[0];
      },
      auraPermanentAttrConfigs() {
        const info = this.auraPermanentAttrInfo || {};
        return Array.isArray(info.configs) ? info.configs : [];
      },
      auraPermanentAttrRecords() {
        const info = this.auraPermanentAttrInfo || {};
        return Array.isArray(info.records) ? info.records : [];
      }
    },
    watch: {
      filteredPetsList() {
        this.syncSelectedAuraToVisibleList();
      },
      selectedAuraId() {
        this.loadAuraPermanentAttrInfo();
      }
    },
    created() {
      this.checkMobile();
      // 初始化导航栏状态
      const savedNavState = localStorage.getItem('moyuNavExpanded');
      if (savedNavState !== null) {
        this.navExpanded = savedNavState === 'true';
      }
      const theme = window.localStorage.getItem("isTheme");
      if(theme === "black"){
        this.isDark=true;
      }else{
      }
      this.applyTheme();
      console.log('isMobile:', this.isMobile);
      console.log('window.innerWidth:', window.innerWidth);
      console.log('userName:', this.userName);
      console.log('userAvatar:', this.userAvatar);
      console.log('rank:', this.rank);
      // 监听导航栏展开状态变化
      this.$bus.$on('TOGGLE_NAV', () => {
        this.navExpanded = !this.navExpanded;
        this.saveNavState();
      });

      // 获取用户信息
      this.loadUserInfo();
    },
    mounted() {
      // 添加窗口大小变化监听
      window.addEventListener('resize', this.checkMobile);
      // 调试移动端头部
      console.log('组件挂载完成');
      console.log('移动端头部应该显示:', this.isMobile);
      console.log('当前窗口宽度:', window.innerWidth);
    },
    beforeDestroy() {
      this.$bus.$off('TOGGLE_NAV');
      this.stopAutoKick();
      window.removeEventListener('resize', this.checkMobile);
    },
    updated() {
      // 战斗记录定位到底部
      const el = document.getElementById("recording");
      const max = el.scrollHeight - el.clientHeight;
      if (max - el.scrollTop < 80) {
        el.scrollTop = el.scrollHeight;
      }
    },
    components: { playersList,TaskSystemModal,ClanModal ,SectCompeModal,rankingList, updateLog,selectChara,shop, tradingBank,synthesisNew,CaveSystem,CaveFarmSystem,CaveFarmAura,alchemyFurnace,hearthActivity,Im, lockDemonTower,petMap,battleProcess2 },
    methods: {
      getMobileTitle() {
        if (this.currentTab === 'blueprints') {
            return this.showDetail ? '图纸详情' : '图纸列表'
        } else if (this.currentTab === 'delegating') {
            return '委托锻造'
        } else if (this.currentTab === 'history') {
            return '锻造历史'
        }
        return '修仙百艺'
    },

    // 在委托和历史页面添加返回图纸列表功能
    backToBlueprints() {
        this.currentTab = 'blueprints'
        this.showDetail = false
    },
      checkMobile() {
        this.isMobile = window.innerWidth < 768;
        this.isMobile2 = window.innerWidth <= 768;
        if (this.isMobile2) {
          this.navExpanded2 = true;
        }else{
          this.navExpanded2 = false;
        }
      },
      handleClose() {
        console.log('点击关闭按钮');
        this.$emit('close-nav');
      },
      getAptitudeStyle(aptitude) {
        if (!aptitude) return {};

        const apt = Number(aptitude);
        if (apt >= 10) {
          return {
            color: '#ffd700',
            fontWeight: 'bold',
            textShadow: '0 0 10px rgba(255, 215, 0, 0.8)'
          };
        }
        if (apt >= 9) {
          return {
            color: '#ff6b9d',
            fontWeight: 'bold',
            textShadow: '0 0 8px rgba(255, 107, 157, 0.6)'
          };
        }
        if (apt >= 8) {
          return {
            color: '#a335ee',
            fontWeight: 'bold',
            textShadow: '0 0 6px rgba(163, 53, 238, 0.4)'
          };
        }
        if (apt >= 7) {
          return {
            color: '#0070dd',
            fontWeight: 'bold'
          };
        }
        if (apt >= 6) {
          return {
            color: '#1eff00',
            fontWeight: 'bold'
          };
        }
        return {
          color: '#8c94a4'
        };
      },
      handleMobileMenuClick(item) {
        console.log('点击菜单项:', item.name);
        this.mainMenu.forEach(menu => menu.active = false);
        item.active = true;

        // 移动端点击后关闭导航
        if (this.isMobile) {
          this.$emit('close-nav');
        }

        // 这里可以根据item.id执行相应操作
        switch(item.id) {
          case 'task':
            console.log('打开任务榜单');
            break;
          case 'rank':
            console.log('打开排行榜');
            break;
          // ... 其他菜单项处理
        }
      },
      checkScreenSize() {
        this.isMobile = window.innerWidth < 768;
        // 手机端默认收起，PC端默认展开
        if (this.isMobile) {
          this.navExpanded = false;
        } else {
          this.navExpanded = true;
        }
      },
      toggleTheme() {
        const current = localStorage.getItem('isTheme') || 'light';
        const next = current === 'light' ? 'black' : current === 'black' ? 'gray' : 'light';
        localStorage.setItem('isTheme', next);
        this.applyTheme();
        this.$bus.$emit('themeChanged', next);
        const names = { light: '白天', black: '夜间', gray: '灰度' };
        this.$Message.success({ content: `已切换到${names[next]}模式`, duration: 1.5 });
      },
      applyTheme() {
        const html = document.documentElement;
        const body = document.body;
        const theme = localStorage.getItem('isTheme') || 'light';
        this.isDark = theme === 'black';
        this.isGray = theme === 'gray';
        html.classList.remove('light-theme', 'dark-theme', 'gray-theme');
        body.classList.remove('light-theme', 'dark-theme', 'gray-theme');
        const cls = theme === 'black' ? 'dark-theme' : theme === 'gray' ? 'gray-theme' : 'light-theme';
        html.classList.add(cls);
        body.classList.add(cls);
      },
      // 导航栏相关方法
     /* toggleNav() {
        this.navExpanded = !this.navExpanded;
        this.saveNavState();
        this.$bus.$emit('NAV_TOGGLE', this.navExpanded);
      },*/
      // 切换自动踢人开关
      toggleAutoKick() {
        this.autoKickEnabled = !this.autoKickEnabled;

        if (this.autoKickEnabled) {
          this.$Message.success('已开启自动踢人，每一分钟检查一次');
          this.startAutoKick();
        } else {
          this.$Message.info('已关闭自动踢人');
          this.stopAutoKick();
        }
      },

      // 开始自动踢人
      startAutoKick() {
        // 清除已有定时器
        if (this.autoKickTimer) {
          clearInterval(this.autoKickTimer);
        }

        // 立即执行一次检查
        this.checkAndKickZeroReward();

        // 设置定时器
        this.autoKickTimer = setInterval(() => {
          this.checkAndKickZeroReward();
        }, this.autoKickInterval);
      },

      // 停止自动踢人
      stopAutoKick() {
        if (this.autoKickTimer) {
          clearInterval(this.autoKickTimer);
          this.autoKickTimer = null;
        }
      },

      // 检查并踢出次数为0的队员
      checkAndKickZeroReward() {
        //重新查询list
        this.armyBoundary();
        // 检查是否是队长
        if (!this.isTeamLeader) {
          return;
        }
        if (this.organizeList.charaInfoVoList.length === 5 || this.organizeList.charaInfoVoList.length === 3) {
          // 踢出最后一个加入的队员
          const lastMember = this.organizeList.charaInfoVoList[this.organizeList.charaInfoVoList.length - 1];

          let num = lastMember.rewardNum;
          if(num === 0){
            //挑战图自动t人
            this.kickOut(lastMember)
          }
        }
      },

      // 检查是否是队长
      isTeamLeader() {
        if (!this.organizeList.charaInfoVoList) return false;
        const currentMember = this.organizeList.charaInfoVoList.find(
          member => member.charaId === this.user.charaId
        );
        return currentMember && currentMember.status === 0;
      },
      // 分割线

      saveNavState() {
        localStorage.setItem('moyuNavExpanded', this.navExpanded.toString());
      },

      toggleUserMenu() {
        if (this.navExpanded) {
          // 显示用户菜单
          this.subMenuModal = {
            visible: true,
            title: '用户中心',
            type: 'user'
          };
          this.subMenus.user = [
            { id: 'info', name: '个人信息', icon: 'ios-person' },
            { id: 'switch', name: '切换角色', icon: 'md-swap', handler: 'openSelectChara' },
            { id: 'password', name: '修改密码', icon: 'ios-lock', handler: 'changePas' },
            { id: 'logout', name: '退出登录', icon: 'ios-exit', handler: 'out' }
          ];
        } else {
          this.navExpanded = true;
          setTimeout(() => this.toggleUserMenu(), 300);
        }
      },

      toggleSettings() {
        this.subMenuModal = {
          visible: true,
          title: '系统设置',
          type: 'settings'
        };
        this.subMenus.settings = [
          { id: 'sell', name: '出售设置', icon: 'ios-settings', handler: 'openSetEject' },
          { id: 'update', name: '更新日志', icon: 'ios-document',  handler: 'openStrategy'  },
          { id: 'notify', name: '通知设置', icon: 'ios-notifications' },
          { id: 'shortcut', name: '快捷键设置', icon: 'ios-keypad' }
        ];
      },

      handleMenuClick(item) {
        // 重置所有菜单项的激活状态
        this.mainMenu.forEach(menu => menu.active = false);
        item.active = true;
        // 移动端点击后通知父组件关闭导航
        if (this.isMobile) {
          this.$emit('close-nav'); // 触发关闭事件
        }

        // 根据菜单项ID执行相应操作
        switch(item.id) {
          case 'task':
            this.openTaskRacking();
            break;
          case 'rank':
            this.PlanEject = true;
            break;
          case 'team':
            this.openOrganize();
            break;
          case 'farm':
            this.$router.push({ name: 'SpiritFarm' });
            break;
          case 'monopoly':
            this.$router.push({ name: 'XianMonopoly' });
            break;
          case 'rogue':
            this.$router.push({ name: 'TaixuRogue' });
            break;
          case 'sect':
            this.openSect();
            break;
          case 'pet':
            this.openCaveAura();
            break;
          case 'forge':
            this.openforge();
            break;
          case 'classicCave':
            this.openClassicCave();
            break;
          case 'market':
            this.openTradingBankEject();
            break;
          case 'tower':
            this.openLockDemonTowerEject();
            break;
          case 'help':
            window.open('https://docs.qq.com/aio/DTW9xUFBmam9oSEt1?p=acCvutVfClbUnm1Wt5Qsul', '_blank');
            break;
          case 'update':
            this.openStrategy();
            break;
        }
      },

      handleQuickAction(action) {
        if (action.handler && typeof this[action.handler] === 'function') {
          this[action.handler]();
        }
      },

      handleSubMenuItem(item) {
        this.subMenuModal.visible = false;
        if (item.handler && typeof this[item.handler] === 'function') {
          this[item.handler]();
        }
      },
      // 获取角色的全部消息
      refreshUserInfo() {
        this.$http
          .get(
            "/gamepassport/getGameCharacterActivity?charaId=" +
            this.getCookie("charaId")
          )
          .then((res) => {
            this.userName = res.data.data.roleName || '修仙者';
            this.rank = res.data.data.rank || '修仙者';
            this.userAvatar = res.data.data.face || 'https://example.com/avatar.jpg';

            this.playerLevel = res.data.data.level;
            this.playerExp = res.data.data.exp || 0;
            this.playerMaxExp = res.data.data.upgradeExp || 0;
            // console.log(this.user);
          })
          .catch((err) => {
            this.$Message.warning(err.data.msg);
          });
      },
      handleCaveExpUpdated() {
        this.refreshUserInfo();
        this.$emit('user-activity-refresh');
      },
      getGradeColor(grade) {
        const colors = {
          1: 'green', 2: 'blue', 3: 'purple',
          4: 'red', 5: 'orange', 6: 'cyan'
        }
        return colors[grade] || 'default'
      },
      // 格式化方法
      formatCombatPower(power) {
        if (!power) return '0'
        if (power < 10000) {
          return power.toString()
        } else if (power < 100000000) {
          return (power / 10000).toFixed(1) + '万'
        } else {
          return (power / 100000000).toFixed(1) + '亿'
        }
      },
      getTypeName(type) {
        const names = { 1: '辅助', 2: '输出', 3: '防御' }
        return names[type] || '未知'
      },

      getElementColor(element) {
        const colors = {
          1: '#ffd700', 2: '#52c41a', 3: '#1890ff', 4: '#ff4d4f', 5: '#faad14',
          6: '#87d068', 7: '#722ed1'
        }
        return colors[element] || '#666'
      },

      getElementName(element) {
        const names = {
          1: '金', 2: '木', 3: '水', 4: '火', 5: '土',
          6: '风', 7: '雷', 8: '冰'
        }
        return names[element] || '未知'
      },
      handleAuraFilterChange() {
        this.syncSelectedAuraToVisibleList();
      },
      resetAuraFilters() {
        this.auraFilters = {
          keyword: "",
          type: 0,
          element: 0,
          grade: 0,
          aptitude: "",
          status: -1,
          sortKey: "combat",
          sortOrder: "desc",
        };
      },
      matchAuraAptitude(aptitude, rule) {
        const value = Number(aptitude);
        if (!Number.isFinite(value)) return false;
        if (rule === "10-") return value < 10;
        if (rule === "9-") return value < 9;
        if (rule === "8-") return value < 8;
        if (rule === "7-") return value < 7;
        if (rule === "6-") return value < 6;
        return true;
      },
      getAuraSortValue(item, sortKey) {
        const fieldMap = {
          combat: 'auraCombot',
          level: 'auraLevel',
          aptitude: 'auraAptitude',
          grade: 'auraGrade',
          starvation: 'auraStarvationValue',
          life: 'auraLife',
          attack: 'auraAttack',
          magicAttack: 'auraMagicAttack',
          speed: 'auraActionSpeed'
        };
        const field = fieldMap[sortKey] || 'auraCombot';
        const value = Number(item && item[field]);
        return Number.isFinite(value) ? value : 0;
      },
      syncSelectedAuraToVisibleList() {
        const visibleList = Array.isArray(this.filteredPetsList) ? this.filteredPetsList : [];
        if (!visibleList.length) {
          this.selectedAuraId = null;
          this.selectedAura = null;
          this.selectedAuraSkillKey = null;
          return;
        }
        const matchedPet = visibleList.find((pet) => pet.auraId === this.selectedAuraId);
        if (matchedPet) {
          this.selectedAura = matchedPet;
          this.syncSelectedAuraSkill();
          return;
        }
        this.selectedAuraId = visibleList[0].auraId;
        this.selectedAura = visibleList[0];
        this.syncSelectedAuraSkill();
      },
      getGradeName(grade) {
        const names = {
          1: '普通', 2: '稀有', 3: '灵级', 4: '王级',
          5: '域级', 6: '圣级', 7: '神级'
        }
        return names[grade] || '未知'
      },
      loadUserInfo() {
        this.refreshUserInfo();
        // 从localStorage或API加载用户信息
        /*const userData = this.$store.state.user || {};
        this.userName = userData.name || '修仙者';
        this.userAvatar = userData.face || 'https://example.com/avatar.jpg';*/

        // 更新任务徽章
        const taskItem = this.mainMenu.find(item => item.id === 'task');
        if (taskItem && this.uncompletedTaskCount > 0) {
          taskItem.badge = this.uncompletedTaskCount;
        }
      },
        // 切换页码
        changePage (val) {
          this.discipleCurrentPage = val
          var _start = (val - 1) * this.disciplePageSize
          var _end = val * this.disciplePageSize
          this.discipleTempData = this.discipleTableData.slice(_start, _end)
        },
        handleExplore ({ map, pet, days }) {
          console.log('探索参数', { mapId: map.id, petId: pet.petId, days })
          // axios.post('/api/explore', { mapId: map.id, petId: pet.petId, days })
        },
        // 搜索
        search () {
          this.discipleCurrentPage = 1
          this.getList();
        },
        // 搜索出来的数据做处理
        getList () {
          let search = this.inputContent
          let list = this.discipleTableData.filter(item => item.discipleName.includes(search)) // 查出来的数据
          this.discipleTotal = list.length
          let start = (this.discipleCurrentPage - 1) * this.disciplePageSize
          let end = this.discipleCurrentPage * this.disciplePageSize
          var temp = list.slice(start, end) // 截取之后的数据
          this.discipleTempData = temp
        },
        cs1() {
            this.$Notice.open({
                title: '还没有呢 别着急',
                desc: '淡炒稀饭(长老终结者)'
            });
        },
        // 返回品质颜色
        distinguishColor(color) {
            if (color == 1) {
                return "#000";
            } else if (color == 2) {
                return "#c5c52f";
            } else if (color == 3) {
                return "#049c04";
            } else if (color == 4) {
                return "#005aff";
            } else if (color == 5) {
                return "#ff00e0";
            } else if (color == 6) {
                return "#ff0000";
            } else {
                return "#ff00c3e0";
            }
        },
        // 打开任务榜单
        openTaskRacking() {
          this.RackingEject = true;
        },

        // 处理任务统计数据更新
        updateTaskStatistics(statistics) {
          this.uncompletedTaskCount = statistics.uncompletedCount || 0;
        },
        // 处理弹窗显示状态变化
        handleModalVisible(visible) {
          if (visible) {
            if (this.$refs.taskSystemNormal && this.$refs.taskSystemNormal.getPlaters) {
              this.$refs.taskSystemNormal.getPlaters();
            }
            if (this.$refs.taskSystemReward && this.$refs.taskSystemReward.getPlaters) {
              this.$refs.taskSystemReward.getPlaters();
            }
          }
        },
        show2 (index) {
          this.itemEject2=true;
          this.item=this.sectknapsackList[index]
        },
        duel(index){
          this.duelEject=true;
          this.discipleId=this.discipleTempData[index].id;
          //清空
          this.recording = [];
          this.monsterList = [];
          //this.gameCharacterVO = [];
          this.startTheBattle();
        },
        /**
         * 获取cookie
         */
        getCookie(name) {
          const value = `; ${document.cookie}`;
          const parts = value.split(`; ${name}=`);
          if (parts.length === 2) return parts.pop().split(';').shift();
          return '';
        },

        /**
         * 原有的刷新方法（需要在外部定义）
         */
        refreshPackage() {
          // 原有的刷新背包方法
          // 这个方法需要在父组件中定义
          if (this.$parent && this.$parent.refreshPackage) {
            this.$parent.refreshPackage();
          }
        },
        handleDuel(disciple) {
          console.log('决斗事件触发:', disciple);
          // 处理切磋
          this.duelEject=true;
          this.discipleId=disciple;
          //清空
          this.recording = [];
          this.monsterList = [];
          //this.gameCharacterVO = [];
          this.startTheBattle();
        },
        handleDuel2(disciple) {
          console.log('决斗事件触发:', disciple);
          // 处理切磋
          this.duelEject=true;
          //清空
          this.recording = [];
          this.monsterList = [];
          //this.gameCharacterVO = [];
          this.startTheBattle2(disciple);
        },
        /**
         * 原有的刷新材料背包方法
         */
        refreshMaterialPackage() {
          // 原有的刷新材料背包方法
          if (this.$parent && this.$parent.refreshMaterialPackage) {
            this.$parent.refreshMaterialPackage();
          }
        },
        // 灵宠状态
        PetsStatus(val) {
            if (val == 0) {
                return "休息";
            } else {
                return "出战";
            }
        },
        // 品级 普通-稀有-灵级-王级-域级-圣级-神级
        PetsGrade(val) {
            if (val == 1) {
                return "普通";
            } else if (val == 2) {
                return "稀有";
            } else if (val == 3) {
                return "灵级";
            }  else if (val == 4)  {
              return "王级";
            } else  if (val == 5) {
              return "域级";
            } else  if (val == 6) {
              return "圣级";
            } else {
              return "神级";
            }
        },
        // 新增品级样式方法
        getGradeClass(grade) {
          if (!grade) return 'grade-1';

          const gradeNum = Number(grade);
          return `grade-${gradeNum}`;
        },
        // 元素状态
        petsEl(val) {
            if (val == 1) {
                return "金";
            } else if (val == 2) {
                return "木";
            } else if (val == 3) {
                return "水";
            } else if (val == 4) {
                return "火";
            } else if (val == 5) {
                return "土";
            } else if (val == 6) {
                return "风";
            } else if (val == 7) {
                return "雷";
            } else if (val == 8) {
              return "冰";
            } else {
                return "无";
            }
        },
        // 类型
        petsType(val) {
            if (val == 1) {
                return "辅助灵力";
            } else if (val == 2) {
                return "输出力道";
            } else if (val == 3) {
                return "防御";
            } else {
                return "未知";
            }
        },
        realmColorF() {
            var roundColor = Math.round(Math.random() * 5);
            if (roundColor == 1) {
                return "red";
            } else if (roundColor == 2) {
                return "skyblue";
            } else if (roundColor == 3) {
                return "#2700ff";
            } else if (roundColor == 4) {
                return "#d800ff";
            } else if (roundColor == 5) {
                return "#06c11d";
            }
        },

        // 获取组队地图列表
        TeamMapList() {
            this.$http.get("/gameAmry/queryMapList").then((res) => {
                this.mapList = res.data.data;
            });
        },

        // 查看战斗记录
        CombatRecord() {
            if (!this.mapName) {
                this.$Notice.warning({title:"提示",desc:"请在上方选择一个地图"});
                return;
            }
            for (var i = 0; i < this.mapList.length; i++) {
                if (this.mapName == this.mapList[i].mapName) {
                    this.mapid = this.mapList[i].mapId;
                }
            }
            this.$http
                .post(
                    "/gameAmry/getAmryRecord?charaNo=" +
                    this.$store.state.user.accountId +
                    "&mapId=" +
                    this.mapid
                )
                .then((res) => {
                    this.combatRecordProcess = res.data.data;

                    for (let i = 0; i < this.combatRecordProcess.length; i++) {
                        if (this.combatRecordProcess[i].gameItemsList != null) {
                            this.combatRecordProcess[
                                i
                            ].gameItemsList1 = this.combatRecordProcess[i].gameItemsList.map(
                                (val) => {
                                    return val.itemName;
                                }
                            );
                        }
                    }

                    this.recordStatus = true;
                    setTimeout(() => {
                        this.recordStatus = false;
                    }, 10000);
                })
                .catch((err) => {
                  this.$Message.warning(err.data.msg);
                });
        },
        // 打开组队
        openOrganize() {
            this.organizeEject = true;
            this.armyBoundary();
        },
        // 进入队伍界面
        armyBoundary() {
          let charaId2 = this.getCookie("charaId");
          this.$http
                .post("/gameAmry/armyBoundary/?charaId=" + charaId2)
                .then((res) => {
                    if (res.data.msg == "无队伍") {
                        this.teamStatus = 0;
                        this.organizeList = {};
                        this.organizeList.charaInfoVoList = [{}, {}, {}];
                        this.$bus.$emit("teamStatusMsg1", "无队伍了");
                    } else {
                        this.teamStatus = 1;
                        this.organizeList = res.data.data;
                        this.TeamMapList(); // 获取组队地图列表
                        this.$bus.$emit("teamStatusMsg", "有队伍了");
                    }
                })
                .catch((err) => {
                  this.$Message.warning(err.data.msg);
                });
        },

        // 打开宗门
        openSect() {
          this.showClan = true;
          this.$nextTick(() => {
            if (this.$refs.clanModalRef) {
              this.$refs.clanModalRef.openSect();
            }
          });
        },
      handleCaveVisibleChange(visible) {
        if (!visible) {
          this.caveVisible = false;
        }
      },
      handleClassicCaveVisibleChange(visible) {
        if (!visible) {
          this.classicCaveVisible = false;
        }
      },
      openClassicCave() {
        this.refreshUserInfo();
        this.caveVisible = false;
        this.classicCaveVisible = true;
      },
        handleClanModalVisible(visible) {
          if (visible) {
            this.clanTitle = '宗门';
          }
        },
        // 打开宗门大比赛事页
        openSectCompe() {
          this.showSectCompe = true;
        },
        // 打开锻造页面
        openforge() {
           //this.forgeEject = true;
           //this.tuzhiList = this.$store.state.tuzhiList;
          // //查询委托锻造列表
           //this.commForging();
          this.refreshUserInfo();
          // 改为打开洞府系统
          // 注意：initData() 由 CaveSystem 的 watch visible 触发，不需要手动调用
          this.classicCaveVisible = false;
          this.caveVisible = true;
        },
        changepage(index) {
          this.sectknapsack(index);
        },
        changepage2(index) {
          this.gameSectItemBo.pageSize=index;
          this.sectknapsack(1);
        },
      //捐献的确定
      changeSmelt() {
        this.$http
          .post(
            "/gameSect/playersConsignWare?charaId=" +
            this.getCookie("charaId") +
            "&packId=" +
            this.packItemId
          )
          .then((res) => {
           // this.$Notice.success({title:res.data.msg});
            this.$Message.success("捐献成功");
            this.refreshPackage(); // 获取全部包裹
            //this.refreshUserInfo();
          })
          .catch((err) => {
            //this.$Notice.warning({title:err.data.msg});
            this.$Message.warning(err.data.msg);
          });
      },

        sectknapsack(index =1){
          //this.gameSectItemBo.name=name;
          this.$http
            .post(
              "/gameSect/getSectWare", {
          ...this.gameSectItemBo,
              charaId: this.getCookie("charaId"),
              page:index,
            }).then((res) => {
              this.sectknapsackList = res.data.rows;
              this.total = res.data.records
              //this.$Notice.success({title:res.data.msg});
            });
        },
      // 打开队伍列表
        join() {
            this.armyListEject = true;
            this.$http.post("/gameAmry/getArmyList?armyName").then((res) => {
                this.armyList = res.data.data;
            });
        },

        // 队伍列表里的加入按钮
        JoinTheTeam(item) {
            this.$http
                .post(
                    "/gameAmry/playerJoinAmry/?charaId=" +
                    this.getCookie("charaId") +
                    "&amryId=" +
                    item.armyId
                )
                .then((res) => {
                    //this.$Notice.success({title:"提示",desc:res.data.msg});
                    this.$Message.success("加入成功");
                    this.armyBoundary();
                    this.armyListEject = false;
                }).catch((err) => {
                    this.$Message.warning(err.data.msg);
                 });
        },

        // 创建队伍
        establish() {
            this.armyEject = true;
        },

        // 队伍名字的确定
        changeEstablish() {
          if(!this.armyLevel){
            this.$Notice.warning({title:"提示",desc:"等级必须输入"});
            return;
          }
            this.$http
                .post(
                    "/gameAmry/playerCreateAmry/?charaId=" +
                    this.getCookie("charaId") +
                    "&armyName=" +
                    this.armyName+
                  "&armyLevel=" +
                  this.armyLevel+
                  "&armyType=" +
                  this.armyType
                )
                .then((res) => {
                    this.$Notice.success({title:"提示",desc:res.data.msg});
                    if (res.data.msg == "OK") {
                        this.armyBoundary();
                    }
                    console.log(res, "队伍名字的确定");
                }).catch((err) => {
                     this.$Message.warning(err.data.msg);
                });
        },

        // 退出队伍
        quitTheTeam() {
            this.$http
                .post("/gameAmry/exitAmry/?charaId=" + this.getCookie("charaId"))
                .then((res) => {
                    this.armyBoundary();
                   this.$Message.success("已退出");
                }).catch((err) => {
                     this.$Message.warning(err.data.msg);
                  });
        },

        // 踢出队伍失败
        kickOut(item) {
            this.$http
                .post(
                    "/gameAmry/kickOutAmry/?charaId=" +
                    this.getCookie("charaId") +
                    "&charaNo=" +
                    item.charaNo
                )
                .then((res) => {
                    this.armyBoundary();
                     this.$Message.success(res.data.msg);
                }).catch((err) => {
                   this.$Message.warning(err.data.msg);
                 });
        },

        // 自动出售设置的获取
        getPackageBo() {
            this.$http
                .post(
                    "/gameMarket/getScreenPackage?charaId=" + this.getCookie("charaId")
                )
                .then((res) => {
                    const responseData = res.data.data || {};
                    this.gamePackageBo = {
                        ...this.createDefaultGamePackageBo(),
                        ...responseData,
                    };
                    if (this.gamePackageBo.isOpen !== 1 && this.gamePackageBo.isOpen !== 2) this.gamePackageBo.isOpen = 1;
                    this.gamePackageBo.quality = this.normalizeQualityList(this.gamePackageBo.quality);
                    this.gamePackageBo.partList = this.normalizeNumberList(this.gamePackageBo.partList);
                    this.gamePackageBo.elementList = this.normalizeNumberList(
                        responseData.elementList || responseData.keepElementList || this.gamePackageBo.elementList
                    );
                })
                .catch((err) => {
                  this.$Message.warning((err.data && err.data.msg) || "自动处理规则读取失败");
                });
        },
        // 打开设置
        openSetEject() {
            this.setEject = true;
            this.gamePackageBo = {
                ...this.createDefaultGamePackageBo(),
                ...this.gamePackageBo,
            };
            this.getPackageBo(); //自动出售设置的获取
        },

          // 设置的确定
        changeSet() {
            const normalizedQuality = this.normalizeQualityList(this.gamePackageBo.quality);
            const normalizedPartList = this.normalizeNumberList(this.gamePackageBo.partList);
            const normalizedElementList = this.normalizeNumberList(this.gamePackageBo.elementList);
            const rawMinLevel = this.gamePackageBo.minLevel;
            const rawMaxLevel = this.gamePackageBo.maxLevel;
            const minLevel = Number(this.gamePackageBo.minLevel);
            const maxLevel = Number(this.gamePackageBo.maxLevel);
            if (rawMinLevel === null || rawMinLevel === "" || !Number.isInteger(minLevel) || minLevel < 0) {
                this.$Notice.warning({title:"提示",desc:"最低等级不能为空"});
                return;
            }
            if (rawMaxLevel === null || rawMaxLevel === "" || !Number.isInteger(maxLevel) || maxLevel < 0) {
                this.$Notice.warning({title:"提示",desc:"最高等级不能为空"});
                return;
            }
            if (minLevel > maxLevel) {
                this.$Notice.warning({title:"提示",desc:"最小等级不能大于最大等级"});
                return;
            }
            if (normalizedQuality.length <= 0 || normalizedPartList.length <= 0 || normalizedElementList.length <= 0) {
                this.$Notice.warning({title:"提示",desc:"品质、部位、元素都需要至少选择一项"});
                return;
            }
            if (this.gamePackageBo.isOpen !== 1 && this.gamePackageBo.isOpen !== 2) {
                this.$Notice.warning({title:"提示",desc:"请选择自动出售或自动分解"});
                return;
            }
            this.gamePackageBo.quality = normalizedQuality;
            this.gamePackageBo.partList = normalizedPartList;
            this.gamePackageBo.elementList = normalizedElementList;

            this.autoRuleSaving = true;
            this.$http
                .post("/gameMarket/setScreenPackage", {
                    ...this.gamePackageBo,
                    charaId: this.getCookie("charaId"),
                    minLevel,
                    maxLevel,
                    quality: normalizedQuality.join(","),
                    partList: normalizedPartList,
                    elementList: normalizedElementList,
                })
                .then((res) => {
                    this.autoRuleSaving = false;
                    if (res.data.status && res.data.status !== 200) {
                        this.$Message.warning(res.data.msg || "规则保存失败");
                        return;
                    }
                    this.setEject = false;
                    this.$Message.success("自动处理规则已保存");
                })
                .catch((err) => {
                    this.autoRuleSaving = false;
                    this.$Message.warning((err.data && err.data.msg) || "规则保存失败");
                });
        },

        normalizeQualityList(value) {
            const source = Array.isArray(value)
                ? value
                : (typeof value === "string" ? value.split(",") : []);
            const allowed = new Set(["1", "2", "3", "4", "5", "6"]);
            return [...new Set(source
                .map(item => String(item == null ? "" : item).trim())
                .filter(item => allowed.has(item)))];
        },

        normalizeNumberList(value) {
            const source = Array.isArray(value)
                ? value
                : (typeof value === "string" ? value.split(",") : []);
            return [...new Set(source
                .map(item => Number(item))
                .filter(item => Number.isInteger(item) && item > 0))];
        },

        selectAllAutoRule(field) {
            const optionMap = {
                quality: this.autoRuleQualityOptions,
                partList: this.autoRulePartOptions,
                elementList: this.autoRuleElementOptions,
            };
            this.$set(this.gamePackageBo, field, (optionMap[field] || []).map(option => option.value));
        },

        clearAutoRule(field) {
            this.$set(this.gamePackageBo, field, []);
        },

        createDefaultGamePackageBo() {
            return {
                charaId: "",
                isOpen: 1,
                maxLevel: 999,
                minLevel: 1,
                quality: [],
                partList: [],
                elementList: [],
            };
        },

        // 退出登录
        out() {
            this.$http
                .post("/gamepassport/logout?userId=" +
                    this.getCookie("userId"))
                .then((res) => {
                  this.$Message.success("已登出");
                })
                .catch((err) => {
                  this.$Message.warning(err.data.msg);
                });

            this.$bus.$emit("tcdlMsg", "退出登录那里发送过来的");
            this.$router.push({ name: "Login" });
        },

        // 打开攻略
        openStrategy() {
            this.strategy = true;
        },
        // 打开频道
        openPindao() {
          this.pindao = true;
        },
        openHelpDocument() {
          this.subMenuModal.visible = false;
          window.open('https://docs.qq.com/aio/DTW9xUFBmam9oSEt1?p=xIqZQN3IUMi1LPc9VQMzhv', '_blank');
        },
        // 打开切换账号页面
        openSelectChara() {
          this.selectChara = true;
        },
        // 打开修改密码
        changePas() {
            this.originalPas = "";
            this.newPas = "";
            this.confirmPas = "";
            this.pasEject = true;
        },

        // 修改密码弹出框的确认
        confirmPassword() {
            this.$http
                .post(
                    "/gamepassport/updatePwd?userId=" +
                    this.getCookie("userId") +
                    "&originalPwd=" +
                    this.originalPas +
                    "&newPwd=" +
                    this.newPas +
                    "&confirmPwd=" +
                    this.confirmPas
                )
                .then((res) => {
                    this.$Message.success("修改成功");
                })
                .catch((err) => {
                  this.$Message.warning(err.data.msg);
                });
        },

        // 打开兑换码
        openExchange() {
            this.exchangeEject = true;
            this.exchange = "";
        },
        openTradingBankEject() {
            this.tradingBankEject = true
            setTimeout(() => {
                this.$nextTick(() => {
                    this.$refs.tradingBank.getTradingBankList();
                })
            }, 1000)
        },
        openLockDemonTowerEject() {
            this.lockDemonTowerEject = true
            setTimeout(() => {
                this.$nextTick(() => {
                    this.$refs.lockDemonTower.getMapList();
                })
            }, 1000)
            // this.$http.get("gameBussiness/getBussinessList?page=" + 1 + "&pageSize=" + 20 + '&bussinessName' + '').then((res) => {
            //     console.error(res.data.rows)
            //     this.tradingBankList = res.data.rows;
            //     this.tradingBankEject = true
            // })
            // .catch((err) => {
            //     this.$Notice.warning({title:"获取黑市失败,请联系管理员"});
            // });
        },

        openSectBossTower(targetMap) {
            this.lockDemonTowerEject = true
            setTimeout(() => {
                this.$nextTick(() => {
                    if (this.$refs.lockDemonTower && this.$refs.lockDemonTower.openWithMap) {
                        this.$refs.lockDemonTower.openWithMap(targetMap);
                    }
                })
            }, 300)
        },

        // 移动端洞府灵兽园与导航栏统一使用洞府版真灵页面。
        openPetsFromCave() {
            this.openCaveAura();
        },
        openCaveAura() {
            this.caveVisible = false;
            this.PetsEject = false;
            this.caveAuraVisible = true;
        },
        openPets() {
             this.caveAuraVisible = true;
            this.checkShenSkillList = [];
            this.zhenBookList = [];
            this.$http
                .post("/gameAura/getCharaPet?charaId=" + this.getCookie("charaId"))
                .then((res) => {
                    this.PetsList = res.data.data;
                    this.syncSelectedAuraToVisibleList();
                    this.syncSelectedAuraSkill();
                    this.PetsList.forEach(d => {
                        // if (d.auraName == '炽焰狼') {
                        //     d.auraIcon = 'https://image8.cdn2.seaart.ai/2023-08-20/14895646759741445/cf76999a4e2f0b1292fae1028b336054ed2718eb_high.webp'
                        // } else if (d.auraName == '三眼灵猴') {
                        //     d.auraIcon = 'https://image2.cdn2.seaart.ai/2023-07-15/45424216264773/b073af8d407351509583f8c3d18e5d6cdfe014a4_high.webp'
                        // } else if (d.auraName == '白泽') {
                        //     d.auraIcon = 'https://image1.cdn2.seaart.ai/2023-09-14/17164851793156101/d6b47ec23aca10d2a11515c572a0fe46ea298546_high.webp'
                        // } else {
                        //     d.auraIcon = 'https://image2.cdn2.seaart.ai/2023-09-24/18026210080650245/5884d0a350e8de9ff67c896ef91cf2a188bb9f42_high.webp'
                        // }
                    })
                })
                .catch((err) => {
                  this.$Message.warning(err.data.msg);
                });
            //神通技能
            this.checkShenSkillList = this.buildUniquePetSkillBookList(this.$store.state.shenSkillList, [20]);
            this.zhenBookList = this.buildUniquePetSkillBookList(this.$store.state.shenSkillList, [17]);
        },
        // 新增：选择真灵的方法
        selectAura(item) {
          this.selectedAuraId = item.auraId;
          this.selectedAura = item;
          if (this.isMobile) {
            this.auraMobileDetailVisible = true;
          }
          this.syncSelectedAuraSkill();
        },
        backToAuraList() {
          this.auraMobileDetailVisible = false;
        },
        async loadAuraPermanentAttrInfo() {
          if (!this.selectedAuraId) {
            this.auraPermanentAttrInfo = null;
            this.auraPermanentMaterialBag = [];
            return;
          }
          this.auraPermanentAttrLoading = true;
          try {
            const [infoRes, materialRes] = await Promise.all([
              this.$http.post(
                "/gameAura/getAuraPermanentAttrInfo?charaId=" + this.getCookie("charaId") + "&petId=" + this.selectedAuraId
              ),
              this.$http.post(
                "/gameChara/getCharaMaterial/?charaId=" + this.getCookie("charaId")
              )
            ]);
            if (infoRes.data && infoRes.data.status === 200) {
              this.auraPermanentAttrInfo = infoRes.data.data || {};
            } else {
              this.auraPermanentAttrInfo = null;
              this.$Message.warning((infoRes.data && infoRes.data.msg) || "获取永久强化信息失败");
            }
            this.auraPermanentMaterialBag = (materialRes.data && Array.isArray(materialRes.data.data))
              ? materialRes.data.data.filter((item) => Number(item && item.itemType) === 21)
              : [];
          } catch (error) {
            this.auraPermanentAttrInfo = null;
            this.auraPermanentMaterialBag = [];
            this.$Message.warning("获取永久强化信息失败");
          } finally {
            this.auraPermanentAttrLoading = false;
          }
        },
        canUseAuraPermanentAttr(config) {
          if (!config) return false;
          const ownCount = Number(config.ownCount || 0);
          const useCount = Number(config.useCount || 0);
          const maxCount = Number(config.maxCount || 0);
          return ownCount > 0 && useCount < maxCount && !!this.getAuraPermanentAttrPackItemId(config.itemId);
        },
        getAuraPermanentAttrPackItemId(itemId) {
          const localList = Array.isArray(this.auraPermanentMaterialBag) ? this.auraPermanentMaterialBag : [];
          const storeList = (this.$store && this.$store.state && Array.isArray(this.$store.state.materialList))
            ? this.$store.state.materialList
            : [];
          const materialList = localList.length ? localList : storeList;
          const matched = materialList.find((item) =>
            String(item && item.itemId) === String(itemId) && Number(item && item.itemNum) > 0
          );
          return matched ? matched.packItemId : "";
        },
        formatAuraPermanentAttrDelta(attrType, value) {
          const num = Number(value || 0);
          if (!Number.isFinite(num)) return "0";
          if (["CRIT_RATE", "CRIT_DAMAGE", "SPEED", "ELEMENT_BONUS"].includes(String(attrType || ""))) {
            return (num * 100).toFixed(1) + "%";
          }
          if (Math.abs(num % 1) < 0.000001) {
            return String(Math.round(num));
          }
          return num.toFixed(2);
        },
        async useAuraPermanentAttrMaterial(config) {
          if (!this.selectedAuraId || !config || !config.itemId) {
            this.$Message.warning("强化参数不完整");
            return;
          }
          const packItemId = this.getAuraPermanentAttrPackItemId(config.itemId);
          if (!packItemId) {
            this.$Message.warning("背包里没有可用的对应材料记录，请先刷新材料背包");
            return;
          }
          if (!this.canUseAuraPermanentAttr(config)) {
            this.$Message.warning("当前材料不可使用");
            return;
          }
          this.usingAuraPermanentAttrItemId = config.itemId;
          try {
            const res = await this.$http.post(
              "/gameAura/useAuraPermanentAttrMaterial?charaId=" +
              this.getCookie("charaId") +
              "&petId=" + this.selectedAuraId +
              "&packItemId=" + packItemId
            );
            if (res.data && res.data.status === 200) {
              const data = res.data.data || {};
              this.$Message.success(
                (data.attrName || config.attrName || "属性") +
                " +" + this.formatAuraPermanentAttrDelta(data.attrType || config.attrType, data.delta || config.delta)
              );
              await this.refreshSelectedAuraDetail();
              await this.loadAuraPermanentAttrInfo();
              this.refreshMaterialPackage();
            } else {
              this.$Message.warning((res.data && res.data.msg) || "强化失败");
            }
          } catch (error) {
            this.$Message.warning("强化失败");
          } finally {
            this.usingAuraPermanentAttrItemId = null;
          }
        },
        async refreshSelectedAuraDetail() {
          try {
            const res = await this.$http.post("/gameAura/getCharaPet?charaId=" + this.getCookie("charaId"));
            if (res.data && res.data.status === 200) {
              this.PetsList = Array.isArray(res.data.data) ? res.data.data : [];
              this.syncSelectedAuraToVisibleList();
              this.syncSelectedAuraSkill();
            }
          } catch (error) {
          }
        },
        async toggleAuraFollow(item) {
          const target = item || this.selectedAura;
          if (!target || !target.auraId) {
            this.$Message.warning("未找到对应真灵");
            return;
          }
          const followed = Number(target.auraFollowed || 0) === 1 ? 0 : 1;
          try {
            const res = await this.$http.post(
              "/gameAura/toggleAuraFollow?charaId=" +
              this.getCookie("charaId") +
              "&petId=" + target.auraId +
              "&followed=" + followed
            );
            this.$Message.success((res.data && (res.data.data || res.data.msg)) || (followed === 1 ? "关注成功" : "取消关注成功"));
            await this.refreshSelectedAuraDetail();
          } catch (err) {
            this.$Message.warning((err && err.data && err.data.msg) || "操作失败");
          }
        },
        getAuraSkillsByType(type) {
          const skills = this.selectedAura && this.selectedAura.gamePetSKillList
            ? this.selectedAura.gamePetSKillList
            : [];
          return skills.filter((item) => {
            if (type === 'passive') {
              return this.isAuraPassiveSkill(item);
            }
            return !this.isAuraPassiveSkill(item);
          });
        },
        isAuraPassiveSkill(skill) {
          const skillType = String((skill && skill.skillType) || '');
          return skillType !== '' && skillType !== '1';
        },
        getAuraPassiveTypeLabel(skill) {
          const skillType = String((skill && skill.skillType) || '');
          if (skillType === '2') return '被动';
          if (skillType === '3') return '光环';
          return '被动';
        },
        getAuraPassiveTypeColor(skill) {
          const skillType = String((skill && skill.skillType) || '');
          if (skillType === '2') return 'gold';
          if (skillType === '3') return 'cyan';
          return 'default';
        },
        getAuraSkillKey(skill) {
          if (!skill) return null;
          return skill.skillId || skill.id || skill.skillName;
        },
        isSelectedAuraSkill(skill) {
          return this.getAuraSkillKey(skill) === this.selectedAuraSkillKey;
        },
        selectAuraSkill(skill) {
          this.selectedAuraSkillKey = this.getAuraSkillKey(skill);
        },
        syncSelectedAuraSkill() {
          const skills = this.selectedAura && this.selectedAura.gamePetSKillList
            ? this.selectedAura.gamePetSKillList
            : [];
          if (!skills.length) {
            this.selectedAuraSkillKey = null;
            return;
          }
          const hasCurrent = skills.some((item) => this.getAuraSkillKey(item) === this.selectedAuraSkillKey);
          if (!hasCurrent) {
            this.selectedAuraSkillKey = this.getAuraSkillKey(skills[0]);
          }
        },
        // 真灵觉醒提示材料按钮
        breach2() {
            this.JuexinEject = true;
            this.$http
                .post("/gameAura/getLingCaiAwaken?charaId=" + this.getCookie("charaId")+"&petId="+ this.selectedAuraId)
                .then((res) => {
                    this.zhenlingStuff = res.data.data;
                })
                .catch((err) => {
                   this.$Message.warning(err.data.msg);
                });
        },
         // 真灵觉醒按钮
         breachRequirt() {
            this.$http
                .post("/gameAura/completeSoulAwakening?charaId=" + this.getCookie("charaId")+"&petId="+ this.selectedAuraId)
                .then((res) => {
                  this.$Message.success(res.data.msg);
                })
                .catch((err) => {
                  this.$Message.warning(err.data.msg);
                });
        },
        // 真灵放生 确认框
        ReleaseZhen(item) {
          this.zhenitem=item;
          this.releaseEject=true;
        },
        // 真灵放生
        Release() {
            if (this.zhenitem.auraStatus == 1) {
                this.$Notice.warning({title:"提示",desc:"真灵出战中, 不能放生"});
                return
            }
            if (Number(this.zhenitem.auraFollowed || 0) === 1) {
                this.$Notice.warning({title:"提示",desc:"已关注真灵不能放生，请先取消关注"});
                return
            }
            this.$http
                .post("/gameAura/goSpiritRelease?charaId=" + this.getCookie("charaId") + "&petId=" + this.zhenitem.auraId)
                .then((res) => {
                    //this.$Notice.success({title:"提示",desc:res.data.msg});
                    this.$Message.success(res.data.data);
                    // 真灵放生重新获取
                    this.$http
                        .post("/gameAura/getCharaPet?charaId=" + this.getCookie("charaId"))
                        .then((res) => {
                            this.PetsList = res.data.data;
                        })
                        .catch((err) => {
                          this.$Message.warning(err.data.msg);
                        });
                })
                .catch((err) => {
                  this.$Message.warning(err.data.msg);
                });
        },
        // 批量放生确认框
        batchReleaseConfirm() {
          const list = this.filteredPetsList;
          if (!list.length) {
            this.$Message.warning("当前没有可放生的真灵");
            return;
          }
          this.batchReleaseEject = true;
        },
        // 批量放生
        batchRelease() {
          const petIds = this.filteredPetsList
            .filter(item => item.auraStatus !== 1 && Number(item.auraFollowed || 0) !== 1)
            .map(item => item.auraId);
          if (!petIds.length) {
            this.$Message.warning("当前筛选的真灵均为出战中或已关注，无法放生");
            return;
          }
          this.$http
            .post("/gameAura/batchSpiritRelease?charaId=" + this.getCookie("charaId"), petIds)
            .then((res) => {
              const result = res.data.data;
              if (result.failCount > 0) {
                this.$Message.warning("放生成功 " + result.successCount + " 只，失败 " + result.failCount + " 只");
              } else {
                this.$Message.success("成功放生 " + result.successCount + " 只真灵");
              }
              this.$http
                .post("/gameAura/getCharaPet?charaId=" + this.getCookie("charaId"))
                .then((res) => {
                  this.PetsList = res.data.data;
                })
                .catch((err) => {
                  this.$Message.warning(err.data.msg);
                });
            })
            .catch((err) => {
              this.$Message.warning(err.data.msg);
            });
        },
        // 真灵出战
        goToWar(item) {
            let auraStatus = item.auraStatus == 0 ? 1 : 0
            this.$http
                .post("/gameAura/goToWarByAure?charaId=" + this.getCookie("charaId") + "&petId=" + item.auraId + "&aureStatus=" + auraStatus)
                .then((res) => {
                    this.$Message.success(res.data.data);
                    this.openPets()
                })
                .catch((err) => {
                  this.$Message.warning(err.data.msg);
                });
        },
        // 真灵改名
        editName(item) {
          this.auraName = "";
          this.nameEject = true;
          this.auraId =item.auraId;
        },
        // 真灵学习神通
        learnZhenSkill(item) {
          this.shenEject = true;
          this.packItemId = "";
          this.checkShenSkillList = this.buildUniquePetSkillBookList(this.$store.state.shenSkillList, [20]);
          //petId
          this.auraId =item.auraId;
        },
        openDaShu(item) {
          this.daShuEject = true;
          this.daShuPackItemId = "";
          this.auraId = item.auraId;
          this.zhenBookList = this.buildUniquePetSkillBookList(this.$store.state.shenSkillList, [17]);
        },
        reName() {
          this.$http
            .post("/gameAura/goSpiritRename?charaId=" + this.getCookie("charaId") + "&petId=" +  this.auraId + "&petName=" + this.auraName)
            .then((res) => {
              this.$Message.success(res.data.data);
              this.openPets()
            })
            .catch((err) => {
              this.$Message.warning(err.data.msg);
            });
        },
        //修炼技能
        xiuLianZhenSKill() {
          if (!this.packItemId) {
            this.$Message.warning("请选择神通");
            return;
          }
          const selectedPackItemId = this.packItemId;
          this.$http
            .post("/gameAura/learnZhenSkill?charaId=" + this.getCookie("charaId") + "&petId=" +  this.auraId + "&packItemId=" + this.packItemId)
            .then((res) => {
              this.$Message.success(res.data.data);
              this.checkShenSkillList = this.checkShenSkillList.filter((item) => String(item.packItemId) !== String(selectedPackItemId));
              this.packItemId = "";
              this.refreshMaterialPackage();
              this.openPets()
            })
            .catch((err) => {
              this.$Message.warning(err.data.msg);
            });
        },
        daShuZhenSkill() {
          if (!this.daShuPackItemId) {
            this.$Message.warning("请选择真灵书");
            return;
          }
          this.$http
            .post("/gameAura/replacePassiveZhenSkill?charaId=" + this.getCookie("charaId") + "&petId=" +  this.auraId + "&packItemId=" + this.daShuPackItemId)
            .then((res) => {
              this.$Message.success(res.data.data);
              this.zhenBookList = this.zhenBookList.filter((item) => String(item.packItemId) !== String(this.daShuPackItemId));
              this.daShuPackItemId = "";
              this.refreshMaterialPackage();
              this.openPets()
            })
            .catch((err) => {
              this.$Message.warning(err.data.msg);
            });
        },
        buildUniquePetSkillBookList(sourceList, allowTypes = []) {
          const list = Array.isArray(sourceList) ? sourceList : [];
          const seen = new Set();
          return list.filter((item) => {
            const itemType = Number(item && item.itemType);
            if (allowTypes.length > 0 && !allowTypes.includes(itemType)) {
              return false;
            }
            const key = item && item.packItemId ? String(item.packItemId) : "";
            if (!key || seen.has(key)) {
              return false;
            }
            seen.add(key);
            return true;
          });
        },
        // 兑换码确定
        changeExchange() {
            this.$http
                .post(
                    "/gamepassport/exchangeCode?charaId=" +
                    this.getCookie("charaId") +
                    "&exchangeCode=" +
                    this.exchange
                )
                .then((res) => {
                  this.$Message.success(res.data.data);
                })
                .catch((err) => {
                  this.$Message.warning(err.data.msg);
                });
            this.$bus.$emit("dhmMsg", "兑换码那里发送过来的");
        },
        // 留言确定
        changeBoard() {
          this.$http
            .post(
              "/gameSect/addSectBoard?charaId=" +
              this.getCookie("charaId") +
              "&msg=" +
              this.boardMsg
            )
            .then((res) => {
              this.$Message.success(res.data.data);
              this.sectBorad();
            })
            .catch((err) => {
              this.$Message.warning(err.data.msg);
            });
          this.$bus.$emit("dhmMsg", "留言那里发送过来的");
        },
        signIn() {
            this.$emit('open-sign-modal');
        },
      async startTheBattle() {
        try {
          const res = await this.$http.post(
              `gameLockDemon/playerDuelRecord?${qs.stringify({
                charaId: this.getCookie("charaId"),
                sectDisId: this.discipleId,
              })}`
            );

          if (res.data.msg != 'OK') {
            this.$Notice.warning({title:"提示",desc:res.data.msg});
            return
          }
          const body = res.data;

          if (body.status == 205) {
            this.$Notice.warning(body.msg);
            // await sleep(6000);
            // this.startTheBattle();
            return;
          }

          const combatResults = body.data
          // 按顺序播报所有的战斗结果
          for (let i = 0; i < combatResults.length; i++) {
            this.monsterList = combatResults[i].gameMonDieList; // 怪物信息
            this.monsterList.forEach((m) => (m.maxLife = m.health));
            if (this.teamStatus != 1) {
              this.gamePetVOList = combatResults[i].gamePetVO; // 怪物信息
              if (combatResults[i].gamePetVO) {
                combatResults[i].gamePetVO = {
                  health: combatResults[i].gamePetVO.life,
                  name: combatResults[i].gamePetVO.auraName,
                  ...combatResults[i].gamePetVO
                }
                this.gameCharacterVO = [combatResults[i].gameCharacterVO, combatResults[i].gamePetVO]; // 人物 加宠物信息信息
                this.gameCharacterVO.forEach((m) => (m.formerHealth = m.health));
              } else {
                this.gameCharacterVO = [combatResults[i].gameCharacterVO]; // 人物加信息
                //this.gameCharacterVO.forEach((m) => (m.maxLife = m.health));
              }
            }
            //清空战斗统计信息
            this.battleTotal=false;
            this.battleTotalList=[];
            await this.boardcastCombatResult(combatResults[i]);
          }
        } catch (err) {
          this.$Notice.warning({title:"提示",desc:"切磋结束"});
        }
      },
      async startTheBattle2(index) {
        try {
          const res = await this.$http.post("/gameAmry/getQiecRecord/?recordId=" + index);
          if (res.data.msg != 'OK') {
            this.$Notice.warning({title:"提示",desc:res.data.msg});
            return
          }
          const body = res.data;

          if (body.status == 205) {
            this.$Notice.warning(body.msg);
            // await sleep(6000);
            // this.startTheBattle();
            return;
          }

          const combatResults = body.data
          this.monsterList = combatResults.gameMonDieList; // 怪物信息
          this.monsterList.forEach((m) => (m.maxLife = m.health));
          this.gameCharacterVO = [combatResults.gameCharacterVO]; // 人物加信息
          //清空战斗统计信息
          this.battleTotal=false;
          this.battleTotalList=[];
          await this.boardcastCombatResult(combatResults);
        } catch (err) {
          this.$Notice.warning({title:"提示",desc:"切磋结束"});
        }
      },
        // 播报战斗返回的日志
        async boardcastCombatResult(result) {
          let combatInfo = result.combatInfo;
          for (let i = 0; i < combatInfo.length; i++) {
            // 每条记录的输出相隔 1.5 秒
            await sleep(1500);
            const record = combatInfo[i];
            //记录战斗统计
            if(this.battleTotalList.length>0){
              var falg=false;
              for (let i = 0; i < this.battleTotalList.length; i++) {
                if(this.battleTotalList[i].name===record.attacker){
                  this.attackTotalDam(record,i);
                  falg=true;
                }
              }
              if(!falg){
                this.attackTotalDam(record,null);
              }
            }else{
              this.attackTotalDam(record,null);
            }
            const targets = this.monsterList.filter(
              (m) => m.name == record.hinjured
            );
            if (targets.length > 0 && targets[0].health >=0) {
              targets[0].health = record.surplusHealth;
            }

            if (this.teamStatus != 1) {
              const targets1 = this.gameCharacterVO.filter(
                (m) => m.name == record.hinjured
              );
              if (targets1.length > 0) {
                targets1[0].health = record.surplusHealth;
              }
            }
            // 1 物理伤害 2灵力伤害 3持续伤害 4恢复血量
            // console.log(record, "战斗日志");
            if (record.hurtType == 5) {
              record.type = "gain";
            } else {
              record.type = "combat";
            }
            this.addRecord(record);
          }
          // 额外增加一个战斗结果的消息记录
          if (result.reHealth <= 0) {
            this.addRecord({
              type: "result",
              result: "战斗失败",
            });
            this.battleTotal=true;
          } else {
            // 物品列表
            // const goods = result.gameItemsList.map((val) => {
            //   return val.itemName;
            // });
            // const droppedGood = goods.length > 0;
            this.addRecord({
              type: "result",
              result: "战斗成功",
              exp: "获得" + result.dropExp + "修为;",
              goods: "物品:" + "无",
              reHealth: result.reHealth,
              reMana: result.reMana,
            });
            this.battleTotal=true;
            // if (droppedGood) {
            //   // 通知神通刷新检查
            //   this.$bus.$emit("skillMsg", "锁妖塔发送过来的");
            //   this.$bus.$emit("synthesisMsg", "锁妖塔发送过来的");
            // }
          }
        },
        attackTotalDam(record,value){
          var battle={
            name: "",
            damage: 0,
            attack: 0,
            lidao: 0,
            lingli: 0,
            zhiliao: 0,
            huilan: 0,
            sustained: 0,
            counterattack: 0,
            control: 0,
          };
          if(value!=null){
            battle=this.battleTotalList[value];
          }
          //名称
          battle.name=record.attacker;
          //伤害  record.hurtNum;
          if(record.hurtType==1){
            //hurtType 1 物理伤害
            battle.damage = battle.damage + record.hurtNum;
            if(record.isSkill==0){
              //普攻
              battle.attack = battle.attack + record.hurtNum;
            }else{
              //神通
              battle.lidao = battle.lidao + record.hurtNum;
            }
          }else if(record.hurtType==2){
            //hurtType 2 灵力伤害
            battle.damage = battle.damage + record.hurtNum;
            if(record.isSkill==0){
              //普攻
              battle.attack = battle.attack + record.hurtNum;
            }else{
              //神通
              battle.lingli = battle.lingli + record.hurtNum;
            }
          }else if(record.hurtType==3){
            //hurtType 3 持续伤害
            battle.damage = battle.damage + record.hurtNum;
            battle.sustained = battle.sustained + record.hurtNum;
          }else if(record.hurtType==4){
            //hurtType 4 反击伤害
            battle.counterattack = battle.counterattack + record.hurtNum;
          }else if(record.hurtType==5){
            //hurtType 5 恢复血量
            battle.zhiliao = battle.zhiliao + record.hurtNum;
          }else if(record.hurtType==6){
            //hurtType 6 回复蓝量
            battle.huilan = battle.huilan + record.hurtNum;
          }else if(record.hurtType==7){
            //hurtType 7 回复血量和蓝量
            battle.zhiliao = battle.zhiliao + record.hurtNum;
          }else if(record.hurtType==9){
            //hurtType 9 持续恢复血量
            battle.zhiliao = battle.zhiliao + record.hurtNum;
          }else if(record.hurtType==10){
            //hurtType 10 特殊技能描述
            battle.control = battle.control + 1;
          }
          if(record.hinjuredConmbatList!=null&&record.hinjuredConmbatList.length>0){
            for (let i = 0; i < record.hinjuredConmbatList.length; i++) {
              if(record.hinjuredConmbatList[i].hurtType===10){
                battle.control = battle.control + 1;
              }else {
                //持续技能伤害 敌人给你造成的 需要加载其他的地方
                for (let t = 0; t < this.battleTotalList.length; t++) {
                  if(this.battleTotalList[t].name===record.hinjuredConmbatList[i].attacker){
                    if(record.hinjuredConmbatList[i].hurtType===9){
                      this.battleTotalList[t].zhiliao = this.battleTotalList[t].zhiliao + record.hinjuredConmbatList[i].hurtNum;
                    }else{
                      this.battleTotalList[t].sustained = this.battleTotalList[t].sustained + record.hinjuredConmbatList[i].hurtNum;
                    }
                  }
                }
              }
            }
          }
          if(value!=null){
            this.battleTotalList[value]=battle;
          }else{
            this.battleTotalList.push(battle);
          }
        },
        addRecord(record) {
          this.recording.push(record);
          // 战斗记录超过一定条数时移除一部分
          if (this.recording.length >= 200) {
            this.recording.splice(0, 100);
          }
        }
    },
};
</script>
<style>


.head-cen {
    width: 98%;
    margin: 0 auto;
    overflow: hidden;
}
.head-cen2 {
  height: 30px;
  line-height: 30px;
  width: 98%;
  margin: 0 auto;
  overflow: hidden;
}
.heade-left {
    float: left;
    background-color: #515a6e;
}
.heade-left ul,
.heade-right ul {
    overflow: hidden;
}
.heade-left ul li,
.heade-right ul li {
    float: left;
    height: 60px;
    padding: 0 10px;
    cursor: pointer;
}
.heade-left ul li:hover,
.heade-right ul li:hover {
    background: #363e4f;
    transition: all 0.6s;
}
.heade-right {
    float: right;
}

.heade-left2 {
  float: left;
  background-color: #FFFFFF;
}
.heade-left2 ul,
.heade-right2 ul {
  overflow: hidden;
}
.heade-left2 ul li,
.heade-right2 ul li {
  float: left;
  height: 60px;
  padding: 0 10px;
  cursor: pointer;
}
.heade-left2 ul li:hover,
.heade-right2 ul li:hover {
  color: #2d8cf0;
  border-bottom: 3px solid #2d8cf0;
}
.heade-right2 {
  float: right;
}

.pasEject /deep/ .ivu-input-wrapper {
    margin-bottom: 20px;
}
.mapLoots p {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    line-height: 2;
}

/* 重要更新或者文字突出 */
.importantFont {
    color: #007eff;
    font-size: 16px;
}

.importantFontRed {
    color: #ff004c;
    font-size: 16px;
}

/* 组队列表 */
.organizeEject /deep/ .ivu-modal-body {
    /* display: flex;
  justify-content: space-between; */
}

.organizeList {
    margin-bottom: 15px;
    overflow: hidden;
    padding: 10px;
}

.organizeList_face {
    width: 100px;
    height: 100px;
    display: block;
    /* border: 1px dashed skyblue; */
    margin: 0 auto 15px;
    border-radius: 5%;
   /* box-shadow: 0px 0px 10px #00adff;*/
    object-fit: cover; /* 覆盖容器，可能会裁剪部分图片 */
    object-position: center; /* 图片的对齐方式 */
}

.organizeList_face::before {
    line-height: 100px;
}

.organizeList_face + span {
    position: absolute;
    font-size: 20px;
    right: 0;
    top: -10px;
    cursor: pointer;
    color: red;
}

.organizeList_name {
    text-align: center;
    font-size: 18px;
    float: left;
    margin-left: 20px;
}

/* 真灵列表  加c是class的意思 */
.PetsListC {
    font-family:'思源黑体', sans-serif ;
    overflow: hidden;
}
.PetsListC > img {
    float: left;
}
.PetsListC .ivu-col{
  border: 1px solid #abb6c0;
  height: 35px;
  line-height: 35px;
  text-indent: 1em;
}

.PetsListC > div {
    float: left;
    margin-left: 15px;
    font-size: 15px;
    width: 482px;
}

.PetsListC > div > span {
    padding: 0 10px;
}

.PetsListC > div p {
  /*  margin-top: 15px;*/
}

.PetsListC > div p span {
    display: inline-block;
    width: 102px;
}
.petsbtn {
    margin-top: 12px;
}
</style>

<style scoped>
/* 基础变量定义 - 与主页面保持一致 */
.light-theme {
  --sidebar-bg: linear-gradient(180deg, rgba(255, 255, 255, 0.95) 0%, rgba(245, 247, 249, 0.95) 100%);
  --sidebar-border: rgba(224, 224, 224, 0.6);
  --menu-item-bg-hover: rgba(45, 140, 240, 0.1);
  --menu-item-color: #515a6e;
  --menu-item-color-hover: #2d8cf0;
  --menu-active-border: #4975d4;
  --user-info-bg: rgba(45, 140, 240, 0.1);
  --quick-actions-bg: rgba(245, 247, 249, 0.8);
  --text-primary: #515a6e;
  --text-secondary: #666;
  --text-title: #333;
  --accent-color: #2d8cf0;
  --quick-icon-color: #2d8cf0;
  --modal-bg: rgba(255, 255, 255, 0.95);
  --user-name-color: #2d8cf0;
  --user-name-font-weight: 500;
}

.dark-theme {
  --bg-primary: #373e57;
  --bg-card: #151728;

  --sidebar-bg: linear-gradient(180deg, rgba(15, 17, 27, 0.98) 0%, rgba(10, 12, 20, 0.98) 100%);
  --sidebar-border: rgba(73, 117, 212, 0.2);
  --menu-item-bg-hover: rgba(73, 117, 212, 0.3);
  --menu-item-color: #9c9cab;
  --menu-item-color-hover: #fff;
  --menu-active-border: #4975d4;
  --user-info-bg: rgba(73, 117, 212, 0.15);
  --quick-actions-bg: rgba(255, 255, 255, 0.03);
  --text-primary: #9c9cab;
  --text-secondary: #808695;
  --text-title: #fff;
  --accent-color: #4975d4;
  --quick-icon-color: #d48213;
  --modal-bg: rgba(15, 17, 27, 0.98);
  --user-name-color: #ffffff;
  --user-name-font-weight: 300;
}
/* 左侧导航栏样式 - 修复基础布局 */
.moyu-sidebar-nav {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 80px;
  height: 100vh;
  background: var(--sidebar-bg);
  color: var(--text-primary);
  backdrop-filter: blur(10px);
  border-right: 1px solid var(--sidebar-border);
  z-index: 1000;
  transition: all 0.3s ease;
  overflow: hidden;
}

/* 展开状态 */
.moyu-sidebar-nav.nav-expanded {
  width: 260px;
  box-shadow: 4px 0 15px rgba(0, 0, 0, 0.3);
}
/* 导航容器 */
.moyu-nav-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px 10px;
  overflow: hidden;
}

/* 用户信息区域 - 修复显示问题 */
.moyu-user-info {
  display: flex;
  align-items: center;
  padding: 12px 10px;
  margin-bottom: 20px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s ease;
  background: var(--user-info-bg);
  border: 1px solid var(--sidebar-border);
  min-height: 60px;
  overflow: hidden;
}

.moyu-user-info:hover {
  background: var(--menu-item-bg-hover);
  transform: translateX(5px);
}

.moyu-user-avatar {
  flex-shrink: 0;
  border: 2px solid rgba(73, 117, 212, 0.5);
  box-shadow: 0 0 10px rgba(73, 117, 212, 0.3);
}


.moyu-user-name {
  margin-left: 12px;
  font-size: 14px;
  font-weight: var(--user-name-font-weight);
  color: var(--user-name-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  opacity: 0;
  transition: opacity 0.3s ease;
  max-width: 0;
}

/* 展开状态下显示用户名 */
.moyu-sidebar-nav.nav-expanded .moyu-user-name {
  opacity: 1;
  max-width: 100%;
  margin-left: 12px;
}

.moyu-user-arrow {
  color: var(--text-secondary);
  transition: transform 0.3s ease;
  opacity: 0;
}
.moyu-sidebar-nav.nav-expanded .moyu-user-arrow {
  opacity: 1;
}

.moyu-user-info:hover .moyu-user-arrow {
  transform: translateX(3px);
}
.theme-switcher {
  padding: 8px 0;
  text-align: center;
}

.theme-button {
  width: 70px;
  transition: all 0.3s ease;
}

.theme-button:hover {
  transform: scale(1.05);
}
/* 主菜单区域 */
.moyu-main-menu {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px 0;
}

.moyu-main-menu::-webkit-scrollbar {
  width: 4px;
}

.moyu-main-menu::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}

.moyu-main-menu::-webkit-scrollbar-thumb {
  background: rgba(73, 117, 212, 0.5);
  border-radius: 2px;
}

.moyu-menu-item {
  display: flex;
  align-items: center;
  padding: 12px 10px;
  margin-bottom: 6px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
  color: var(--menu-item-color);
  white-space: nowrap;
  min-height: 44px;
}

.moyu-menu-item:hover {
  background: var(--menu-item-bg-hover);
  color: var(--menu-item-color-hover);
  transform: translateX(5px);
  box-shadow: 0 3px 10px rgba(73, 117, 212, 0.2);
}


.moyu-menu-item.active {
  background: linear-gradient(90deg, rgba(73, 117, 212, 0.3) 0%, rgba(73, 117, 212, 0.1) 100%);
  color: var(--menu-item-color-hover);
  border-left: 3px solid var(--menu-active-border);
}

.moyu-menu-icon {
  font-size: 18px;
  min-width: 24px;
  margin-right: 12px;
  color: inherit;
  flex-shrink: 0;
}

.moyu-menu-text {
  font-size: 13px;
  font-weight: 500;
  opacity: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: opacity 0.3s ease;
  max-width: 0;
}
/* 展开状态下显示菜单文字 */
.moyu-sidebar-nav.nav-expanded .moyu-menu-text {
  opacity: 1;
  max-width: 100%;
}

.moyu-sidebar-nav:hover .moyu-menu-text,
.moyu-sidebar-nav.nav-expanded .moyu-menu-text {
  opacity: 1;
}

.moyu-menu-badge {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

/* 快捷操作区域 */
.moyu-quick-actions {
  margin-bottom: 20px;
  padding: 15px;
  background: var(--quick-actions-bg);
  border-radius: 10px;
  border: 1px solid var(--sidebar-border);
  opacity: 0;
  transition: all 0.3s ease;
  max-height: 0;
  overflow: hidden;
}

.moyu-sidebar-nav.nav-expanded .moyu-quick-actions {
  opacity: 1;
  max-height: 300px;
  margin-bottom: 20px;
}

.moyu-quick-title {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  color: var(--text-title);
  font-size: 14px;
  font-weight: 500;
}

.moyu-quick-title i {
  margin-right: 6px;
  color: #ff9900;
}


.moyu-quick-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}
.moyu-quick-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.moyu-quick-item:hover {
  background: rgba(73, 117, 212, 0.2);
  transform: scale(1.05);
}

.moyu-quick-icon {
  font-size: 16px;
  color: var(--quick-icon-color);
  margin-bottom: 4px;
}

.moyu-quick-text {
  font-size: 12px;
  color: var(--text-secondary);
  text-align: center;
}

/* 底部功能区 */
.moyu-bottom-menu {
  border-top: 1px solid var(--sidebar-border);
  padding-top: 15px;
  margin-top: auto;
}

.moyu-bottom-menu .moyu-menu-item {
  margin-bottom: 4px;
}

.moyu-bottom-menu .moyu-menu-item:hover {
  background: rgba(255, 255, 255, 0.1);
}

.moyu-settings:hover {
  color: #2d8cf0;
}

.moyu-logout:hover {
  color: #ed4014;
}
/* 子菜单弹窗样式 - 深色主题适配 */
.dark-theme .moyu-submenu-modal >>> .ivu-modal {
  background: var(--modal-bg);
  border: 1px solid var(--sidebar-border);
}

.dark-theme .moyu-submenu-modal >>> .ivu-modal-header {
  background: transparent;
  border-bottom: 1px solid var(--sidebar-border);
}

.dark-theme .moyu-submenu-modal >>> .ivu-modal-header-inner {
  color: var(--text-title);
}

.dark-theme .moyu-submenu-modal >>> .ivu-modal-close {
  color: var(--text-secondary);
}

.dark-theme .moyu-submenu-item {
  color: var(--menu-item-color);
}

.dark-theme .moyu-submenu-item:hover {
  background: var(--menu-item-bg-hover);
  color: var(--menu-item-color-hover);
}

/* 底部功能区 */
.dark-theme .moyu-bottom-menu {
  border-top: 1px solid var(--sidebar-border);
}

.dark-theme .moyu-bottom-menu .moyu-menu-item:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* 按钮样式适配 */
.dark-theme .theme-button {
  background: var(--accent-color);
  border-color: var(--accent-color);
  color: #fff;
}
.dark-theme .ivu-table {
  background: var(--bg-card) !important;
  border-color: var(--border-color) !important;
  color: var(--text-primary) !important;
}
.light-theme .theme-button {
  background: #fff;
  border-color: #dcdee2;
  color: #515a6e;
}
/* 白天主题特殊效果 */
.light-theme .moyu-user-name {
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
/* 添加全局过渡效果 */
* {
  transition: background-color 0.3s ease,
  border-color 0.3s ease,
  color 0.3s ease,
  transform 0.3s ease;
}
@media (min-width: 768px) {
  /* 悬浮展开效果 */
  .moyu-sidebar-nav:hover {
    width: 260px;
  }

  .moyu-sidebar-nav:hover .moyu-menu-text,
  .moyu-sidebar-nav:hover .moyu-user-name,
  .moyu-sidebar-nav:hover .moyu-user-arrow,
  .moyu-sidebar-nav:hover .moyu-quick-actions {
    opacity: 1;
    max-width: 100%;
  }

  .moyu-sidebar-nav:hover .moyu-quick-actions {
    max-height: 300px;
  }
  .moyu-sidebar-nav {
    width: 80px;
  }

  .moyu-sidebar-nav.nav-expanded {
    width: 260px;
  }

  .moyu-menu-text {
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .moyu-sidebar-nav.nav-expanded .moyu-menu-text {
    opacity: 1;
  }

  .mobile-header,
  .mobile-overlay {
    display: none !important;
  }
}
/* 手机端样式 */
@media (max-width: 767px) {
  .moyu-sidebar-nav.nav-expanded {
    width: 100%;
    max-width: 320px;
  }
  .moyu-sidebar-nav {
    width: 0;
    transform: translateX(-100%);
    z-index: 1001;
  }

  .moyu-sidebar-nav.nav-expanded {
    width: 280px;
    transform: translateX(0);
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.4);
  }

  .moyu-nav-container {
    width: 280px;
    padding: 0;
  }

  /* 移动端头部 */
  .mobile-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background: linear-gradient(135deg, var(--accent-color) 0%, rgba(var(--accent-color), 0.8) 100%);
    color: white;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .mobile-header-content {
    display: flex;
    align-items: center;
    flex: 1;
  }

  .mobile-avatar {
    border: 2px solid rgba(255, 255, 255, 0.3);
    margin-right: 12px;
  }

  .mobile-user-info {
    flex: 1;
  }

  .mobile-user-name {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 4px;
  }

  .mobile-user-rank {
    font-size: 12px;
    opacity: 0.9;
  }

  .mobile-close {
    font-size: 22px;
    cursor: pointer;
    opacity: 0.8;
    transition: opacity 0.2s;
    margin-left: 10px;
  }

  .mobile-close:hover {
    opacity: 1;
  }

  /* PC端用户信息在移动端隐藏 */
  .moyu-user-info {
    display: none;
  }

  .moyu-main-menu {
    padding: 15px;
  }

  /* 菜单文字在移动端始终显示 */
  .moyu-menu-text {
    opacity: 1 !important;
    max-width: 100% !important;
  }

  /* 底部菜单调整 */
  .moyu-bottom-menu {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    padding: 15px;
    border-top: 1px solid var(--sidebar-border);
  }

  .moyu-bottom-menu .moyu-menu-item {
    flex-direction: column;
    text-align: center;
    padding: 12px;
    margin: 0;
  }

  .moyu-bottom-menu .moyu-menu-icon {
    margin-right: 0;
    margin-bottom: 6px;
  }

  /* 遮罩层 */
  .mobile-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    backdrop-filter: blur(2px);
  }
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.moyu-menu-item {
  animation: fadeIn 0.3s ease forwards;
}

/* 主题切换时的特殊效果 */
.theme-switch-transition {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 暗色主题下的特殊样式优化 */
.dark-theme .moyu-sidebar-nav {
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.4);
}

.dark-theme .moyu-menu-icon {
  filter: drop-shadow(0 0 2px rgba(73, 117, 212, 0.3));
}

/* 亮色主题的特殊样式 */
.light-theme .moyu-sidebar-nav {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.95) 0%, rgba(245, 247, 249, 0.95) 100%);
  color: #515a6e;
}

.light-theme .moyu-user-info {
  background: rgba(45, 140, 240, 0.1);
  border: 1px solid rgba(45, 140, 240, 0.2);
}
.light-theme .moyu-user-info:hover .moyu-user-name {
  color: #1890ff; /* 悬停时使用更亮的蓝色 */
  text-shadow: 0 0 10px rgba(24, 144, 255, 0.4);
}
.light-theme .moyu-menu-item {
  color: #515a6e;
}
.dark-theme .moyu-user-info:hover .moyu-user-name {
  color: #5c9eff; /* 悬停时使用稍亮的蓝色 */
}
/* 夜间主题特殊效果 */
.dark-theme .moyu-user-name {
  text-shadow: 0 0 4px rgba(255, 255, 255, 0.2);
}
.light-theme .moyu-menu-item:hover {
  background: rgba(45, 140, 240, 0.1);
  color: #2d8cf0;
}

.light-theme .moyu-menu-item.active {
  background: linear-gradient(90deg, rgba(45, 140, 240, 0.2) 0%, rgba(45, 140, 240, 0.05) 100%);
  border-left: 3px solid #2d8cf0;
}

.light-theme .moyu-quick-actions {
  background: rgba(245, 247, 249, 0.8);
  border: 1px solid rgba(224, 224, 224, 0.6);
}

.light-theme .moyu-quick-icon {
  color: #197dbe;
}

.light-theme .moyu-quick-text {
  color: #666;
}

/* 平滑滚动条 */
.moyu-main-menu::-webkit-scrollbar {
  width: 4px;
}

.moyu-main-menu::-webkit-scrollbar-track {
  background: var(--quick-actions-bg);
}

.moyu-main-menu::-webkit-scrollbar-thumb {
  background: var(--accent-color);
  border-radius: 2px;
}

/* 确保导航栏在所有主题下都正确显示 */
.moyu-sidebar-nav * {
  box-sizing: border-box;
}
/* 子菜单弹窗样式 */
.moyu-submenu-modal >>> .ivu-modal {
  background: rgba(25, 28, 40, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(73, 117, 212, 0.3);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
}

.moyu-submenu-modal >>> .ivu-modal-header {
  background: transparent;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 16px 24px;
}

.moyu-submenu-modal >>> .ivu-modal-header-inner {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
}

.moyu-submenu-modal >>> .ivu-modal-close {
  color: rgba(255, 255, 255, 0.6);
}

.moyu-submenu-modal >>> .ivu-modal-body {
  padding: 0;
  max-height: 400px;
  overflow-y: auto;
}

.moyu-submenu-content {
  padding: 8px;
}

.moyu-submenu-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 4px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;

}

.moyu-submenu-item:hover {
  background: rgba(73, 117, 212, 0.2);
  color: #fff;
  transform: translateX(5px);
}

.moyu-submenu-icon {
  margin-right: 12px;
  font-size: 16px;
  color: #4975d4;
}

.moyu-submenu-text {
  flex: 1;
  font-size: 14px;
}

/* 暗色主题适配 */
.blackBackGroup .moyu-sidebar-nav {
  background: rgba(15, 17, 27, 0.98);
}

.blackBackGroup .moyu-menu-item {
  color: #9c9cab;
}

.blackBackGroup .moyu-menu-item:hover {
  color: #fff;
  background: rgba(73, 117, 212, 0.3);
}

.blackBackGroup .moyu-quick-actions {
  background: rgba(255, 255, 255, 0.03);
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.moyu-menu-item {
  animation: fadeIn 0.3s ease forwards;
}

.moyu-menu-item:nth-child(1) { animation-delay: 0.05s; }
.moyu-menu-item:nth-child(2) { animation-delay: 0.1s; }
.moyu-menu-item:nth-child(3) { animation-delay: 0.15s; }
.moyu-menu-item:nth-child(4) { animation-delay: 0.2s; }
.moyu-menu-item:nth-child(5) { animation-delay: 0.25s; }
.moyu-menu-item:nth-child(6) { animation-delay: 0.3s; }
.moyu-menu-item:nth-child(7) { animation-delay: 0.35s; }
.moyu-menu-item:nth-child(8) { animation-delay: 0.4s; }
.moyu-menu-item:nth-child(9) { animation-delay: 0.45s; }
.moyu-menu-item:nth-child(10) { animation-delay: 0.5s; }


label {
  content: attr(data-numbers);
  font-family: 'Roboto', sans-serif !important; /* 为数字设置字体 */
}
.knapsack > div {
  margin-right: 20px;
  margin-bottom: 20px;
}

.Equipment p {
  color: white;
}

/* 地图和战斗场景 */
.monster {
  display: flex;
  justify-content: space-between;
  /* margin-bottom: 40px; */
  margin-bottom: 8px;
  margin-top: 8px;
}
.monstercenter {
  justify-content: center;
}
/*  战斗场景  */
.recording {
  max-height: 274px;
  overflow: auto;
  transition: all 0.4s;
}


/* 整体样式 */
.sect-treasure {
  padding: 16px;
  background-color: #f5f7fa;
}

/* 信息提示区域 */
.info-section {
  margin-bottom: 20px;
}

.info-card {
  background: linear-gradient(135deg, #fdfcfb 0%, #e2d1c3 100%);
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #d4af37;
}

.info-title {
  font-size: 18px;
  color: #8b4513;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.info-title::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 16px;
  background: #d4af37;
  margin-right: 8px;
  border-radius: 2px;
}

.info-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.info-tag {
  background-color: #f0e6d2;
  color: #8b4513;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  border: 1px solid #d4af37;
}

.info-detail {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  color: #666;
  font-size: 14px;
}

.info-detail .icon {
  margin-right: 8px;
  color: #d4af37;
}

.auto-rule-modal /deep/ .ivu-modal-content {
  overflow: hidden;
  border: 1px solid #d7dde5;
  border-radius: 7px;
  box-shadow: 0 18px 50px rgba(27, 36, 48, .24);
}

.auto-rule-modal /deep/ .ivu-modal-header {
  padding: 17px 22px;
  background: #f7f9fb;
  border-bottom-color: #e6e9ed;
}

.auto-rule-modal /deep/ .ivu-modal-header-inner {
  color: #293542;
  font-size: 18px;
  font-weight: 700;
}

.auto-rule-modal /deep/ .ivu-modal-body {
  padding: 18px 22px 14px;
  background: #fff;
}

.auto-rule-modal /deep/ .ivu-modal-footer {
  padding: 12px 22px 16px;
  background: #f9fafb;
  border-top-color: #e6e9ed;
}

.auto-rule-toolbar {
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
  padding: 8px 12px;
  background: #f5f8fa;
  border: 1px solid #e0e6eb;
  border-radius: 6px;
}

.auto-rule-toolbar > div {
  display: flex;
  align-items: center;
  gap: 12px;
}

.auto-rule-toolbar-label {
  color: #536170;
  font-size: 13px;
  font-weight: 700;
}

.auto-rule-workspace {
  max-height: 64vh;
  overflow-y: auto;
  border: 1px solid #dfe4e9;
  border-radius: 6px;
  background: #fff;
}

.auto-rule-column {
  min-width: 0;
  padding: 0 16px;
}

.auto-rule-column-title {
  position: sticky;
  top: 0;
  z-index: 2;
  min-height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #324252;
  background: #fff;
  border-bottom: 1px solid #e8ebef;
}

.auto-rule-column-title > div {
  font-size: 15px;
  font-weight: 700;
}

.auto-rule-column-title > div .ivu-icon {
  margin-right: 5px;
  color: #397da8;
  font-size: 18px;
}

.auto-rule-column-title > span {
  color: #89929d;
  font-size: 12px;
}

.auto-rule-section {
  padding: 14px 0;
  border-bottom: 1px solid #edf0f3;
}

.auto-rule-section:last-child {
  border-bottom: 0;
}

.auto-rule-section-head {
  min-height: 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 9px;
}

.auto-rule-section-head strong {
  color: #465360;
  font-size: 13px;
}

.auto-rule-section-head > span {
  display: flex;
  gap: 5px;
}

.auto-rule-section-head button {
  min-height: 25px;
  padding: 2px 8px;
  color: #596979;
  background: #f8f9fa;
  border: 1px solid #dfe4e9;
  border-radius: 4px;
  cursor: pointer;
}

.auto-rule-section-head button:hover {
  color: #2f6f98;
  border-color: #9fc0d4;
}

.auto-rule-level-range {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 24px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
}

.auto-rule-level-range > span {
  color: #8a949f;
  text-align: center;
}

.auto-rule-level-range /deep/ .ivu-input-number {
  width: 100%;
}

.auto-rule-option-grid {
  display: grid;
  gap: 8px;
}

.auto-rule-option-grid--quality {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.auto-rule-option-grid--parts {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.auto-rule-option-grid--elements {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.auto-rule-option-grid /deep/ .ivu-checkbox-wrapper {
  min-width: 0;
  min-height: 36px;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 7px 9px;
  color: #596571;
  background: #fafbfc;
  border: 1px solid #e0e4e8;
  border-radius: 5px;
  line-height: 1.25;
  transition: border-color .16s ease, background .16s ease, color .16s ease;
}

.auto-rule-option-grid /deep/ .ivu-checkbox-wrapper:hover {
  color: #2f6f98;
  background: #f4f9fc;
  border-color: #a8c7d9;
}

.auto-rule-option-grid /deep/ .ivu-checkbox-wrapper-checked {
  color: #285f80;
  background: #edf7fc;
  border-color: #78aac7;
  box-shadow: inset 3px 0 0 #3c83ad;
}

.auto-rule-option-grid /deep/ .ivu-checkbox {
  flex: 0 0 auto;
  margin-right: 5px;
}

.auto-rule-quality-dot,
.auto-rule-element-dot {
  width: 8px;
  height: 8px;
  display: inline-block;
  flex: 0 0 auto;
  margin-right: 5px;
  border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(35, 48, 61, .08);
}

.auto-rule-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

@media (max-width: 760px) {
  .auto-rule-modal /deep/ .ivu-modal {
    top: 8px !important;
    width: calc(100vw - 12px) !important;
    margin: 0 6px;
  }

  .auto-rule-modal /deep/ .ivu-modal-body {
    padding: 12px;
  }

  .auto-rule-toolbar,
  .auto-rule-toolbar > div {
    align-items: flex-start;
  }

  .auto-rule-toolbar {
    flex-direction: column;
  }

  .auto-rule-toolbar > div {
    flex-direction: column;
    gap: 7px;
  }

  .auto-rule-option-grid--quality,
  .auto-rule-option-grid--parts,
  .auto-rule-option-grid--elements {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

/* 查询条件区域 */
.search-section {
  margin-bottom: 20px;
}

.search-card {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.search-title {
  font-size: 18px;
  color: #333;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.search-title::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 16px;
  background: #2d8cf0;
  margin-right: 8px;
  border-radius: 2px;
}

.search-form {
  width: 100%;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
}

.form-item {
  flex: 1;
  min-width: 200px;
}

.form-label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.custom-select,
.custom-input {
  width: 100%;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.search-btn {
  min-width: 120px;
}

/* 法器列表区域 */
.list-section {
  margin-bottom: 20px;
}

.list-card {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.list-title {
  font-size: 18px;
  color: #333;
  display: flex;
  align-items: center;
}

.list-title::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 16px;
  background: #19be6b;
  margin-right: 8px;
  border-radius: 2px;
}

.list-count {
  font-size: 14px;
  color: #666;
}

.count-num {
  color: #2d8cf0;
  font-weight: bold;
}

.treasure-table {
  margin-bottom: 20px;
}

.item-name {
  display: flex;
  align-items: center;
}

.item-icon {
  margin-right: 8px;
  color: #ff9900;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.action-btn {
  min-width: 70px;
}

.pagination-section {
  display: flex;
  justify-content: flex-end;
}

.custom-pagination {
  margin-top: 16px;
}

/**真灵**/
/* 模态框整体样式 */
.aura-modal >>> .ivu-modal {
  background: var(--bg-card);
}

.aura-modal >>> .ivu-modal-header {
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
}

.aura-modal >>> .ivu-modal-header-inner {
  color: var(--text-title);
}

.aura-modal >>> .ivu-modal-body {
  background: var(--bg-card);
}

.aura-modal >>> .ivu-modal-footer {
  background: var(--bg-card);
  border-top: 1px solid var(--border-color);
}

/* 布局样式 */
.aura-layout {
  display: flex;
  height: 700px;
}

.aura-follow-btn {
  padding: 0 4px;
  margin-left: 4px;
}

.aura-follow-icon {
  font-size: 18px;
  color: #b7bfd1;
  transition: color 0.2s ease, transform 0.2s ease;
}

.aura-follow-icon.active {
  color: #e25555;
}

.aura-follow-btn:hover .aura-follow-icon,
.aura-follow-detail-btn:hover .ivu-icon {
  transform: scale(1.08);
}

.aura-follow-detail-btn {
  background-color: #fff7f7;
  color: #e25555;
  margin: 0 5px;
  border: 1px solid rgba(226, 85, 85, 0.2);
}

.aura-left {
  width: 30%;
  border-right: 1px solid var(--border-color);
  overflow-y: auto;
  padding-right: 15px;
}

.aura-right {
  width: 70%;
  padding-left: 15px;
  overflow-y: auto;
}

.aura-filter-panel {
  position: sticky;
  top: 0;
  z-index: 2;
  padding-bottom: 12px;
  margin-bottom: 12px;
  background: var(--bg-card);
}

.aura-filter-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 8px;
}

.aura-filter-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
}

.aura-filter-summary {
  margin-top: 8px;
  font-size: 12px;
  color: var(--text-secondary);
}

.aura-mobile-back {
  margin-bottom: 12px;
}

/* 左侧列表样式 */
.aura-list {
  height: 100%;
}

.aura-list-empty {
  padding: 24px 12px;
  text-align: center;
  color: var(--text-secondary);
  border: 1px dashed var(--border-color);
  border-radius: 6px;
  background: var(--bg-progress);
}

.aura-list-item {
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid var(--border-color);
  background: var(--bg-card);
}

.aura-list-item:hover {
  background: var(--bg-hover);
  border-color: var(--accent-color);
}

.aura-list-item.active {
  background: var(--active-color);
  border-color: var(--accent-color);
}

.aura-item-content {
  display: flex;
  align-items: center;
}

.aura-item-icon {
  margin-right: 10px;
}

.aura-icon {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  object-fit: cover;
  border: 1px solid var(--border-light);
}

.aura-item-info {
  flex: 1;
}

.aura-name {
  font-weight: bold;
  margin-bottom: 4px;
  color: var(--text-primary);
}

.aura-brief {
  font-size: 12px;
  color: var(--text-secondary);
}

.separator {
  margin: 0 4px;
  color: var(--text-secondary);
}

.fighting-tag {
  color: var(--button-bg-success);
  font-size: 12px;
  margin-left: 4px;
}

/* 右侧详情样式 */
.aura-detail {
  color: var(--text-primary);
}

.aura-header {
  display: flex;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid var(--border-color);
}

.aura-avatar {
  margin-right: 20px;
}

.aura-avatar-img {
  width: 120px;
  height: 180px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid var(--border-light);
}

.aura-basic-info {
  flex: 1;
}

.aura-title {
  color: var(--text-title);
  margin-bottom: 10px;
  font-size: 18px;
}

.info-row {
  margin-top: 10px;
}

.info-text {
  font-weight: bold;
}

.info-text.accent {
  color: var(--text-accent);
}

.info-text.warning {
  color: #d88228;
}

.info-text.combat {
  color: #de5431;
}

/* 区块标题 */
.aura-detail-tabs {
  margin-top: 12px;
}

.aura-detail-tabs .ivu-tabs-bar {
  margin-bottom: 12px;
}

.aura-detail-tabs .ivu-tabs-tab {
  font-size: 13px;
  padding: 6px 16px;
}

.aura-detail-tabs .ivu-tabs-content {
  margin-bottom: 0;
}

.aura-detail-tabs .ivu-tabs-tabpane {
  padding-bottom: 0 !important;
}

.aura-detail-tabs .ivu-tabs-tabpane > div {
  padding-bottom: 0;
}

.aura-detail-tabs .ivu-tabs-content > .ivu-tabs-tabpane {
  display: block;
  height: auto;
  overflow: visible;
}

.skills-panel {
  margin-bottom: 0;
  padding-bottom: 0;
}

.attributes-grid {
  margin-bottom: 0;
  padding-bottom: 0;
}

.no-skills {
  margin-bottom: 0;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: var(--text-title);
  padding-bottom: 8px;
  border-bottom: 2px solid var(--accent-color);
  margin-bottom: 15px;
}

/* 属性网格 */
.attributes-grid {
  background: var(--bg-progress);
  padding: 15px;
  border-radius: 6px;
  border: 1px solid var(--border-light);
}

.aura-bag-panel {
  background: var(--bg-progress);
  padding: 15px;
  border-radius: 6px;
  border: 1px solid var(--border-light);
}

.aura-bag-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.aura-bag-list {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.aura-bag-item {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  gap: 8px;
  padding: 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid var(--border-light);
}

.aura-bag-name {
  min-height: 42px;
  font-weight: 600;
  line-height: 1.5;
  word-break: break-word;
}

.aura-bag-item .ivu-btn {
  width: 100%;
}

.aura-permanent-panel {
  background: var(--bg-progress);
  padding: 15px;
  border-radius: 6px;
  border: 1px solid var(--border-light);
  margin-bottom: 14px;
}

.aura-permanent-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.aura-permanent-summary {
  color: var(--text-primary);
  font-weight: 600;
}

.aura-permanent-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.aura-permanent-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid var(--border-light);
  background: rgba(255, 255, 255, 0.72);
  transition: border-color 0.2s ease, transform 0.2s ease;
}

.aura-permanent-item:hover {
  border-color: var(--accent-color);
  transform: translateY(-1px);
}

.aura-permanent-item.is-disabled {
  opacity: 0.72;
}

.aura-permanent-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.aura-permanent-name {
  color: var(--text-title);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
}

.aura-permanent-desc {
  color: var(--text-primary);
  font-size: 12px;
  line-height: 1.6;
}

.aura-permanent-meta {
  display: grid;
  grid-template-columns: 1fr;
  gap: 4px;
  color: var(--text-secondary);
  font-size: 12px;
}

.aura-permanent-records {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px dashed var(--border-color);
}

.aura-permanent-records__title {
  color: var(--text-title);
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
}

.aura-permanent-records__list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.aura-permanent-record {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 10px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.52);
  border: 1px solid var(--border-light);
}

.aura-permanent-record .record-name {
  color: var(--text-title);
  font-size: 12px;
  font-weight: 700;
}

.aura-permanent-record .record-value {
  color: var(--accent-color);
  font-size: 13px;
  font-weight: 700;
}

.aura-permanent-record .record-count {
  color: var(--text-secondary);
  font-size: 11px;
}

@media (max-width: 1200px) {
  .aura-bag-list {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .aura-permanent-grid,
  .aura-permanent-records__list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .aura-bag-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .aura-permanent-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .aura-permanent-grid,
  .aura-permanent-records__list {
    grid-template-columns: 1fr;
  }
}

.aura-bag-empty {
  color: var(--text-secondary);
  text-align: center;
  padding: 12px 0;
}

.attribute-row {
  display: flex;
  margin-bottom: 10px;
}

.attribute-item {
  flex: 1;
  padding: 0 10px;
  display: flex;
  align-items: center;
}

.attribute-label {
  color: var(--text-secondary);
  margin-right: 8px;
  min-width: 80px;
}

.attribute-value {
  color: var(--text-primary);
  font-weight: bold;
}

/* 神通网格 */
.skills-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  background: var(--bg-progress);
  padding: 15px;
  border-radius: 6px;
  border: 1px solid var(--border-light);
}

.skill-item {
  padding: 5px;
}

.skills-panel {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.skills-columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.skills-column-title {
  font-size: 14px;
  font-weight: bold;
  color: var(--text-title);
  margin-bottom: 8px;
}

.skills-grid--single {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
}

.skill-card {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  padding: 4px 8px;
  border: 2px solid #2d8cf0;
  border-radius: 6px;
  background: #ffffff;
  color: #2d8cf0;
  cursor: pointer;
  transition: all 0.2s ease;
}

.skill-card:hover {
  border-color: #1f6fd1;
  color: #1f6fd1;
  transform: translateY(-1px);
}

.skill-card--passive {
  border-color: #5cadff;
  color: #2b85e4;
}

.skill-card.is-selected {
  background: #2d8cf0;
  color: #ffffff;
  box-shadow: 0 6px 14px rgba(45, 140, 240, 0.18);
}

.skill-card--passive.is-selected {
  background: #5cadff;
  border-color: #5cadff;
}

.skill-card-name {
  font-size: 11px;
  font-weight: bold;
  line-height: 1.4;
  word-break: break-all;
}

.skill-empty {
  grid-column: 1 / -1;
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed var(--border-color);
  border-radius: 6px;
  color: var(--text-secondary);
  background: var(--bg-primary);
}

.skill-detail-card {
  background: var(--bg-progress);
  border: 1px solid var(--border-light);
  border-radius: 6px;
  padding: 16px;
  min-height: 120px;
}

.skill-detail-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.skill-detail-name {
  font-size: 15px;
  font-weight: bold;
  color: var(--text-title);
}

.skill-detail-body {
  color: var(--text-primary);
  line-height: 1.8;
  min-height: 54px;
  word-break: break-all;
}

.skill-detail-meta {
  margin-top: 10px;
  color: var(--text-secondary);
  font-size: 12px;
}

.skill-empty-detail {
  min-height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
}

.skill-name {
  font-weight: bold;
  color: var(--text-accent);
  cursor: pointer;
}

.skill-name:hover {
  color: var(--accent-hover);
}

.skill-tooltip {
  color: var(--text-primary);
}

/* 描述区域 */
.aura-description {
  background: var(--bg-progress);
  font-size: 12px;
  padding: 18px;
  border-radius: 6px;
  line-height: 1.9;
  color: var(--text-primary);
  border: 1px solid var(--border-light);
  min-height: 110px;
}

.section-title--compact {
  margin-top: 0;
  margin-bottom: 10px;
}

.aura-description--compact {
  padding: 8px 10px;
  min-height: 0;
  line-height: 1.6;
  margin-bottom: 14px;
}

/* 无内容状态 */
.no-skills {
  text-align: center;
  padding: 20px;
  color: var(--text-secondary);
  background: var(--bg-progress);
  border-radius: 6px;
  border: 1px dashed var(--border-color);
}

.no-selection {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: var(--text-secondary);
  font-size: 16px;
}

/* 按钮样式 */
.petsbtn {
  margin-top: 12px;
  text-align: center;
  padding-top: 12px;
  border-top: 1px solid var(--border-color);
}

.petsbtn >>> .ivu-btn {
  margin: 0 5px;
  min-width: 80px;
}

.btn-danger {
  background-color: var(--button-bg-error) !important;
  color: #ffffff !important;
  border: none !important;
}

.btn-danger:hover {
  opacity: 0.9;
}

.btn-primary {
  background-color: var(--button-bg-primary) !important;
  color: var(--button-text-primary) !important;
  border: none !important;
}

.btn-primary:hover {
  background-color: var(--button-bg-primary-hover) !important;
}

.btn-info {
  background-color: #00adff !important;
  color: #ffffff !important;
  border: none !important;
}

.btn-info:hover {
  background-color: #40caff !important;
}

/* 滚动条样式 */
.aura-left::-webkit-scrollbar,
.aura-right::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.aura-left::-webkit-scrollbar-track,
.aura-right::-webkit-scrollbar-track {
  background: var(--bg-progress);
  border-radius: 3px;
}

.aura-left::-webkit-scrollbar-thumb,
.aura-right::-webkit-scrollbar-thumb {
  background: var(--accent-color);
  border-radius: 3px;
}

.aura-left::-webkit-scrollbar-thumb:hover,
.aura-right::-webkit-scrollbar-thumb:hover {
  background: var(--accent-hover);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .aura-layout {
    flex-direction: column;
    height: auto;
    min-height: 0;
  }

  .aura-left,
  .aura-right {
    width: 100%;
    border: none;
    padding: 0;
    margin-bottom: 15px;
  }

  .aura-left {
    max-height: none;
    min-height: 0;
  }

  .aura-filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .aura-filter-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .aura-header {
    flex-direction: column;
  }

  .aura-avatar {
    margin-right: 0;
    margin-bottom: 15px;
    text-align: center;
  }

  .skills-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .aura-filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
/* 方案二精简版：紧凑信息面板式样式 */
.aura-header.panel-compact {
  display: flex;
  background: var(--bg-card);
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
  border: 1px solid var(--border-color);
  box-shadow: 0 2px 6px var(--shadow-color);
}

/* 左侧头像容器 */
.aura-avatar-container {
  margin-right: 20px;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.avatar-frame {
  position: relative;
  width: 100px;
  height: 120px;
  margin-bottom: 10px;
}

.aura-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
  border: 2px solid var(--accent-color);
}

.level-badge {
  position: absolute;
  top: -8px;
  left: -8px;
  background: var(--accent-color);
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  border: 2px solid var(--bg-card);
}

.avatar-status {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  background: var(--button-bg-success);
  color: white;
  border-radius: 12px;
  font-size: 11px;
  font-weight: bold;
  width: 100%;
}

.status-dot {
  width: 5px;
  height: 5px;
  background: white;
  border-radius: 50%;
  margin-right: 5px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* 右侧信息面板 */
.aura-basic-info {
  flex: 1;
  min-width: 0;
}

.info-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.name-grade {
  display: flex;
  align-items: center;
  gap: 8px;
}

.aura-name {
  color: var(--text-title);
  font-size: 16px;
  margin: 0;
  font-weight: 400;
  line-height: 1.2;
}

.combat-box {
  text-align: center;
  min-width: 70px;
  padding: 4px 8px;
  background: rgba(222, 84, 49, 0.1);
  border-radius: 6px;
  border: 1px solid rgba(222, 84, 49, 0.2);
}

.combat-box--under-avatar {
  width: 100%;
  min-width: 0;
  margin-top: 8px;
}

.combat-label {
  font-size: 10px;
  color: var(--text-secondary);
  margin-bottom: 2px;
  text-transform: uppercase;
}

.combat-value {
  font-size: 14px;
  font-weight: bold;
  color: #de5431;
}

/* 修为条 */
.exp-bar-mini {
  margin-bottom: 15px;
}

.exp-info {
  font-size: 12px;
  color: var(--text-secondary);
  margin-bottom: 4px;
}

.exp-progress-container {
  height: 8px;
  background: var(--progress-bg);
  border-radius: 4px;
  overflow: hidden;
}

.exp-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--accent-color), var(--accent-hover));
  border-radius: 4px;
  transition: width 0.3s ease;
}

/* 信息网格 */
.info-grid-compact {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 8px;
  background: var(--bg-primary);
  border-radius: 6px;
  border: 1px solid var(--border-light);
  transition: all 0.2s ease;
}

.info-item:hover {
  border-color: var(--accent-color);
  background: var(--hover-color);
}

.item-icon {
  font-size: 14px;
  margin-right: 8px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: rgba(var(--accent-color-rgb, 45, 140, 240), 0.1);
  flex-shrink: 0;
}

.item-content {
  flex: 1;
  min-width: 0;
}

.item-label {
  color: var(--text-secondary);
  font-size: 10px;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-value {
  color: var(--text-primary);
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .aura-header.panel-compact {
    flex-direction: column;
    padding: 12px;
  }

  .aura-avatar-container {
    margin-right: 0;
    margin-bottom: 15px;
    width: 100%;
  }

  .avatar-frame {
    width: 80px;
    height: 100px;
    margin-bottom: 0;
  }

  .avatar-status {
    width: auto;
    padding: 4px 12px;
  }

  .info-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .combat-box--under-avatar {
    margin-top: 10px;
  }

  .info-grid-compact {
    grid-template-columns: 1fr;
  }

  .skills-columns {
    grid-template-columns: 1fr;
  }

  .skills-grid--single {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .skill-detail-head {
    align-items: flex-start;
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .aura-header.panel-compact {
    padding: 10px;
  }

  .avatar-frame {
    width: 70px;
    height: 90px;
  }

  .level-badge {
    width: 28px;
    height: 28px;
    font-size: 10px;
  }

  .skills-grid--single {
    grid-template-columns: 1fr;
  }

  .aura-name {
    font-size: 14px;
  }

  .combat-value {
    font-size: 12px;
  }
}

.tab-count {
  font-size: 12px;
  color: var(--text-secondary);
  background: var(--bg-primary);
  padding: 1px 6px;
  border-radius: 10px;
  min-width: 20px;
}

/* ===== 空状态样式 ===== */
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: var(--text-secondary);
  background: var(--bg-card);
  border-radius: 8px;
  border: 1px dashed var(--border-color);
}

.empty-state >>> .ivu-icon {
  margin-bottom: 12px;
  opacity: 0.5;
}

.empty-hint {
  font-size: 12px;
  margin-top: 8px;
  opacity: 0.7;
}

/* ===== 图纸详情样式 ===== */
.blueprint-detail {
  height: 100%;
  padding: 20px;
  overflow-y: auto;
}

.detail-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border-color);
}

.blueprint-title {
  color: var(--text-title);
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 8px 0;
}

.blueprint-subtitle {
  display: flex;
  gap: 20px;
  font-size: 13px;
  color: var(--text-secondary);
}

.drawing-id, .forge-type {
  display: flex;
  align-items: center;
  gap: 4px;
}

.detail-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 信息卡片 */
.info-card,
.success-rate-card,
.materials-card {
  background: var(--bg-card);
  border-radius: 8px;
  border: 1px solid var(--border-color);
  overflow: hidden;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid var(--border-color);
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-title);
}

.card-subtitle {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
}

.card-content {
  padding: 16px;
}

.info-card .info-row {
  display: flex;
  margin-bottom: 12px;
  font-size: 14px;
}

.info-card .info-label {
  color: var(--text-secondary);
  min-width: 100px;
}

.info-card .info-value {
  color: var(--text-primary);
  font-weight: 500;
  flex: 1;
}

.info-card .cost {
  color: #d88228;
  font-weight: 600;
}

.success-rate-card >>> .ivu-progress {
  margin-top: 16px;
}


.quantity-info {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 500;
}

.quantity-info .current {
  color: var(--text-primary);
}

.quantity-info .separator {
  color: var(--text-secondary);
}

.quantity-info .required {
  color: var(--text-primary);
}

.material-input {
  width: 120px;
}

.material-input >>> .ivu-input-number {
  width: 100%;
  background: var(--bg-card);
  border-color: var(--border-color);
}

.material-input >>> .ivu-input-number-input {
  color: var(--text-primary);
  text-align: center;
}

/* ===== 无选择状态 ===== */
.no-selection {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.no-selection-content {
  text-align: center;
  max-width: 400px;
}

.no-selection-content >>> .ivu-icon {
  color: var(--text-secondary);
  margin-bottom: 20px;
  opacity: 0.5;
}

.no-selection-content h3 {
  color: var(--text-title);
  font-size: 20px;
  margin-bottom: 12px;
}

.no-selection-content p {
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 24px;
}
/* ===== 列表视图信息 ===== */
.list-view-info {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.info-content {
  text-align: center;
  max-width: 500px;
}

.info-icon >>> .ivu-icon {
  color: var(--accent-color);
  margin-bottom: 24px;
}

.info-text h3 {
  color: var(--text-title);
  font-size: 24px;
  margin-bottom: 16px;
  font-weight: 600;
}

.info-text p {
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 32px;
}

/* 动画效果 */
@keyframes pulse-purple {
  0%, 100% { box-shadow: 0 2px 10px rgba(163, 53, 238, 0.6); }
  50% { box-shadow: 0 2px 20px rgba(163, 53, 238, 1); }
}

@keyframes glow-gold {
  0% { box-shadow: 0 2px 12px rgba(255, 215, 0, 0.7); }
  100% { box-shadow: 0 2px 20px rgba(255, 215, 0, 1); }
}

@keyframes god-glow {
  0% {
    box-shadow: 0 0 15px rgba(255, 51, 102, 0.8);
    transform: scale(1);
  }
  100% {
    box-shadow: 0 0 25px rgba(255, 51, 102, 1);
    transform: scale(1.05);
  }
}

@keyframes god-stream {
  0% { transform: translateX(-100%) translateY(-100%) rotate(45deg); }
  100% { transform: translateX(100%) translateY(100%) rotate(45deg); }
}

/* 深色主题适配 */
.dark-theme .grade-tag {
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .grade-tag {
    padding: 2px 8px;
    font-size: 11px;
    min-width: 36px;
  }
}

/* 真灵装备选择样式 - 一行显示四个 */
.pet-equipment-grid {
  display: flex;
  justify-content: space-between;
  margin: 15px 0;
  flex-wrap: wrap;
  gap: 10px;
}

.pet-equipment-row {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}

.pet-equipment-slot {
  flex: 1;
  min-width: 120px;
  max-width: 150px;
  text-align: center;
}

.slot-label {
  font-size: 14px;
  font-weight: bold;
  color: #515a6e;
  margin-bottom: 8px;
}

.slot-container {
  width: 90px;
  height: 90px;
  border: 2px dashed #dcdee2;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto 8px;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #f8f8f9;
}

.slot-container:hover {
  border-color: #2d8cf0;
  background-color: #ecf5ff;
}


.empty-slot {
  color: #c5c8ce;
}

.slot-icon {
  font-size: 28px;
  font-weight: bold;
  line-height: 1;
  margin-bottom: 5px;
}

.slot-hint {
  font-size: 12px;
}

.equipped-item {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px;
}

.equipped-item .item-icon {
  margin-bottom: 5px;
}
.equipped-item .item-name {
  font-size: 11px;
  font-weight: bold;
  color: #17233d;
  text-align: center;
  word-break: break-all;
  max-height: 28px;
  overflow: hidden;
  margin-bottom: 3px;
}

.equipped-item .item-grade {
  font-size: 10px;
}

.unequip-btn {
  margin-top: 5px;
  font-size: 12px;
  padding: 2px 6px;
}
.element-line {
  font-size: 11px;
  color: #999;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.cave-farm-modal /deep/ .ivu-modal-header,
.cave-farm-modal /deep/ .ivu-modal-footer {
  display: none;
}

.cave-farm-modal /deep/ .ivu-modal-body {
  padding: 0;
}

.ranking-modal .ivu-modal-header,
.ranking-modal .ivu-modal-footer {
  display: none;
}
.ranking-modal .ivu-modal-content {
  background: #f5f9fc;
  border: 1px solid #c9dced;
  border-radius: 8px;
  overflow: hidden;
}
.ranking-modal .ivu-modal-body {
  padding: 0;
  background: #f5f9fc;
}

@media (max-width: 768px) {
  .clan-modal /deep/ .ivu-modal,
  .cave-farm-modal /deep/ .ivu-modal {
    width: calc(100vw - 12px) !important;
    max-width: none !important;
    max-height: calc(100vh - 12px);
    margin: 0 auto;
    top: 6px !important;
    border-radius: 6px;
  }

  .clan-modal /deep/ .ivu-modal-content,
  .cave-farm-modal /deep/ .ivu-modal-content {
    max-height: calc(100vh - 12px);
    overflow: hidden;
    border-radius: 6px;
  }

  .clan-modal /deep/ .ivu-modal-body {
    max-height: calc(100vh - 12px);
    padding: 0;
    overflow: hidden;
  }

  .cave-farm-modal /deep/ .ivu-modal-body {
    max-height: calc(100vh - 12px);
    padding: 0;
    overflow: hidden;
  }

  .ranking-modal .ivu-modal {
    width: calc(100vw - 12px) !important;
    max-width: none !important;
    top: 6px !important;
  }
  .ranking-modal .ivu-modal-content,
  .ranking-modal .ivu-modal-body {
    max-height: calc(100vh - 12px);
    overflow: hidden;
  }

  .mobile-pet-modal /deep/ .ivu-modal {
    width: calc(100vw - 12px) !important;
    max-width: none !important;
    max-height: calc(100vh - 12px);
    margin: 0 auto;
    top: 6px !important;
  }

  .mobile-pet-modal /deep/ .ivu-modal-content,
  .mobile-pet-modal /deep/ .ivu-modal-body {
    max-height: calc(100vh - 12px);
    overflow-x: hidden;
  }
}

</style>





// WEBPACK FOOTER //
// src/components/headers2.vue